import React, { useState } from "react";
import { Dropdown, Button, Badge, Menu, Tag, Switch } from "antd";
import { EllipsisOutlined, StopOutlined, EyeOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import DeleteFunction from "./deleteFunction";
import toast from "react-hot-toast";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import { DateToLocale, ToFirstCapital } from "../Utils/helpers";
import { getProjectData } from ".././Redux/Actions/projectActions";
import { useDispatch } from "react-redux";
import VideoModal from "../Components/Properties Resale/addVideo";
import RentalVideoModal from "../Components/Rental Properties/addVideo";
import VideoModalProject from "../Components/Manage Projects/addVideo";
import AddVrProject from "../Components/Manage Projects/addVr";
import AddARProject from "../Components/Manage Projects/addAr";
import AddVr from "../Components/Properties Resale/addVr";
import AddAR from "../Components/Properties Resale/addAr";
import AddRentalVr from "../Components/Rental Properties/addVr";
import AddRentalAR from "../Components/Rental Properties/addAr";
import { Popconfirm } from "antd";
import { updateProjectIsPopular } from "../../src/Redux/Actions/projectResaleActions";
import ReactDOM from "react-dom";

export const columnsUsers = (currentPage, pageSize, handleSubscriptionToggle, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "User Id",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
    render: (record) => (
      <span style={{ whiteSpace: "nowrap" }}>{record || ""}</span>
    ),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "name",
    key: "user_name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
    width: 180,
    render: (record) => (
      <Tooltip title={record || "N/A"}>
        <span
          style={{
            display: "inline-block",
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "bottom",
          }}
        >
          {record || "N/A"}
        </span>
      </Tooltip>
    ),
  },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
    render: (number, record) =>
      number ? `${record.country_code || ""} ${number}` : "N/A",
  },
  {
    title: "Verification Status",
    align: "center",
    dataIndex: "is_contact_number_verified",
    key: "is_contact_number_verified",
    render: (record) => (record ? "Verified" : "Un-Verified"),
  },
  {
    title: "Properties Booked",
    align: "center",
    dataIndex: "properties",
    key: "properties",
    render: (record) => record?.length || "0",
  },
  {
    title: "Documents",
    align: "center",
    dataIndex: "documents",
    key: "documents",
    ellipsis: false,
    render: (documents) => {
      if (!Array.isArray(documents) || documents.length === 0) {
        return <p style={{ color: "red" }}>No documents</p>;
      }
      return (
        <div style={{ width: "100%", cursor: "pointer", whiteSpace: "nowrap" }}>
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu>
                {documents.map((doc, index) => (
                  <Menu.Item key={index}>
                    <a href={doc.url} target="_blank" rel="noopener noreferrer">
                      {doc.name}
                    </a>
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <span style={{ color: "blue" }}>View Documents</span>
          </Dropdown>
        </div>
      );
    },
  },
  {
    title: "Sign Up Date",
    align: "center",
    dataIndex: "created_at",
    key: "created",
    render: (record) => (
      <span style={{ whiteSpace: "nowrap" }}>
        {record ? new Date(record).toLocaleString() : ""}
      </span>
    ),
  },
  {
    title: "Email Subscribe",
    align: "center",
    dataIndex: "email_subscribe",
    key: "email_subscribe",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 500,
          border: `1px solid ${status === "subscribed" ? "#b7eb8f" : "#ffccc7"}`,
          background: status === "subscribed" ? "#f6ffed" : "#fff2f0",
          color: status === "subscribed" ? "#52c41a" : "#ff4d4f",
        }}>
        {status === "subscribed" ? "Subscribed" : "Unsubscribed"}
      </span>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "unblock" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/manage_users/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item
                key="subscribe"
                onClick={() => handleSubscriptionToggle(record._id, "subscribed")}
                disabled={record.email_subscribe === "subscribed"}
                style={{
                  color:
                    record.email_subscribe === "subscribed"
                      ? "#bfbfbf"
                      : "#52c41a",
                }}
              >
                Subscribe
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item
                key="unsubscribe"
                onClick={() => handleSubscriptionToggle(record._id, "unsubscribed")}
                disabled={record.email_subscribe === "unsubscribed"}
                style={{
                  color:
                    record.email_subscribe === "unsubscribed"
                      ? "#bfbfbf"
                      : "#ff4d4f",
                }}
              >
                Unsubscribe
              </Menu.Item>
            }
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsFAQ = (
  currentPage,
  pageSize,
) => [
    {
      title: "Sr.No.",
      align: "center",
      key: "srno",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Type",
      align: "center",
      dataIndex: "page",
      key: "page",
    },
    {
      title: "Question",
      align: "center",
      dataIndex: "question",
      key: "question",
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: "220px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              margin: "0 auto",
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Answer",
      align: "center",
      dataIndex: "answer",
      key: "answer",
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: "220px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              margin: "0 auto",
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Created Date",
      align: "center",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Actions",
      align: "center",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Dropdown
          trigger={["click"]}
          overlay={
            <Menu>
              <Menu.Item key="View">
                <Link to={`/faq/view/${record._id}`}>View</Link>
              </Menu.Item>
              <Menu.Item key="Edit">
                <Link to={`/faq/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            </Menu>
          }
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

export const columnsProjectReportList = (currentPage, pageSize, fetchDetails, canEdit, handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Project",
    align: "center",
    dataIndex: "project",
    key: "project",
    render: (project) => project?.project_name || "N/A",
  },
  // {
  //   title: "Trust Score",
  //   align: "center",
  //   dataIndex: "trust_score",
  //   key: "trust_score",
  //   render: (score) => score?.value ?? "N/A",
  // },
  // {
  //   title: "Risk Score",
  //   align: "center",
  //   dataIndex: "risk_score",
  //   key: "risk_score",
  //   render: (score) => score?.value ?? "N/A",
  // },
  {
    title: "Report PDF",
    align: "center",
    dataIndex: "report_pdf",
    key: "report_pdf",
    render: (pdf) =>
      pdf?.value ? (
        <a href={pdf.value} target="_blank" rel="noreferrer" style={{ color: "#0D1A52", fontWeight: 500 }}>
          View PDF
        </a>
      ) : (
        <span style={{ color: "#9ca3af" }}>No PDF</span>
      ),
  },
  {
    title: "Notes",
    align: "center",
    key: "note",
    render: (_, record) => {
      const scoreKeys = ["location_advantage", "future_growth", "trust_score", "Livability_score", "risk_score"];
      const totalNotes =
        scoreKeys.reduce((sum, key) => sum + (Array.isArray(record[key]?.note) ? record[key].note.length : 0), 0) +
        (Array.isArray(record.report_pdf?.note) ? record.report_pdf.note.length : 0);

      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 500,
            background: "#f0f4ff",
            color: "#0D1A52",
            border: "1px solid #d0d9f5",
          }}
        >
          {totalNotes} Notes
        </span>
      );
    },
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 500,
          border: `1px solid ${status === "active" ? "#b7eb8f" : "#ffccc7"}`,
          background: status === "active" ? "#f6ffed" : "#fff2f0",
          color: status === "active" ? "#52c41a" : "#ff4d4f",
        }}
      >
        {status === "active" ? "Active" : "Inactive"}
      </span>
    ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/project_report/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/project_report/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
            {canEdit && (
              <Menu.Item
                key="active"
                onClick={() => handleStatusChange(record, "active")}
                disabled={record.status === "active"}
                style={{ color: record.status === "active" ? "#bfbfbf" : "#52c41a" }}
              >
                Mark Active
              </Menu.Item>
            )}
            {canEdit && (
              <Menu.Item
                key="inactive"
                onClick={() => handleStatusChange(record, "inactive")}
                disabled={record.status === "inactive"}
                style={{ color: record.status === "inactive" ? "#bfbfbf" : "#ff4d4f" }}
              >
                Mark Inactive
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsVrShootRequest = () => {
  return [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Requester Name",
      align: "center",
      key: "user_name",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{record?.user_data?.name || "—"}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record?.user_data?.user_id || "—"}</div>
        </div>
      ),
    },
    {
      title: "Contact Number",
      align: "center",
      key: "user_contact",
      render: (_, record) => record?.user_data?.contact_number || "—",
    },
    {
      title: "Email",
      align: "center",
      key: "user_email",
      render: (_, record) => record?.user_data?.email || "—",
    },
    {
      title: "Project",
      align: "center",
      key: "project_name",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{record?.project_data?.project_name || "—"}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record?.project_data?.project_id || "—"}</div>
        </div>
      ),
    },
    {
      title: "Builder",
      align: "center",
      key: "builder_name",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{record?.builder_data?.brand_name || "—"}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record?.builder_data?.organization_name || "—"}</div>
        </div>
      ),
    },
    {
      title: "Created At",
      align: "center",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => DateToLocale(date),
    },
    // {
    //   title: "Actions",
    //   align: "center",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Dropdown
    //       trigger={["click"]}
    //       overlay={
    //         <Menu>
    //           <Menu.Item key="View">
    //             <Link to={`/vr_shoot_request/view/${record._id}`}>View</Link>
    //           </Menu.Item>
    //         </Menu>
    //       }
    //     >
    //       <Button shape="square" icon={<EllipsisOutlined />} />
    //     </Dropdown>
    //   ),
    // },
  ];
};

export const columnsUserViewVrHistory = ({ onDelete, deletingId, canEdit } = {}) => {
  const columns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "User Name",
      align: "center",
      key: "user_name",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 600 }}>{record?.user?.name || "—"}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record?.user?.user_id || "—"}</div>
        </div>
      ),
    },
    {
      title: "Contact Number",
      align: "center",
      key: "user_contact",
      render: (_, record) => record?.user?.contact_number || "—",
    },
    {
      title: "Email",
      align: "center",
      key: "user_email",
      render: (_, record) => record?.user?.email || "—",
    },
    {
      title: "Business Type",
      align: "center",
      dataIndex: "business_type",
      key: "business_type",
      render: (type) => (
        <span style={{ textTransform: "capitalize" }}>{type || "—"}</span>
      ),
    },
    {
      title: "Property / Project",
      align: "center",
      key: "property_or_project",
      render: (_, record) =>
        record?.business_type === "rental" ? (
          <div>
            <div style={{ fontWeight: 600 }}>{record?.rental_property?.property_name || "—"}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{record?.rental_property?.property_id || "—"}</div>
          </div>
        ) : (
          <div>
            <div style={{ fontWeight: 600 }}>{record?.project?.project_name || "—"}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{record?.project?.project_id || "—"}</div>
          </div>
        ),
    },
    {
      title: "Viewed At",
      align: "center",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => DateToLocale(date),
    },
  ];

  if (canEdit) {
    columns.push({
      title: "Actions",
      align: "center",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Dropdown
          trigger={["click"]}
          overlay={
            <Menu>
              {/* <Menu.Item key="View">
                <Link to={`/user_view_vr_history/view/${record._id}`}>View</Link>
              </Menu.Item> */}
              <Menu.Item key="Delete">
                <Popconfirm
                  title="Delete this record?"
                  description="This action cannot be undone."
                  okText="Delete"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true, loading: deletingId === record._id }}
                  onConfirm={() => onDelete(record._id)}
                  onCancel={(e) => e.stopPropagation()}
                >
                  <span
                    style={{ color: "#ff4d4f", cursor: "pointer" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Delete
                  </span>
                </Popconfirm>
              </Menu.Item>
            </Menu>
          }
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnPlans = () => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "plan_name",
    key: "plan_name",
  },
  {
    title: "planId",
    align: "center",
    dataIndex: "plan_id",
    key: "plan_id",
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
  },
  // {
  //   title: "Plan Type",
  //   align: "center",
  //   dataIndex: "plan_type",
  //   key: "plan_type",
  // },
  {
    title: "Plan Interval Type",
    align: "center",
    dataIndex: "period",
    key: "period",
  },

  {
    title: "Plan Interval",
    align: "center",
    dataIndex: "interval",
    key: "interval",
  },

  {
    title: "Created",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Actions",
    align: "center",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/Plan/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsState = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " State Code",
    align: "center",
    dataIndex: "state_code",
    key: "state_code",
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "state_name",
    key: "state_name",
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={
  //           status === "active" || status === "published" ? "green" : "red"
  //         }
  //         text={ToFirstCapital(status)}
  //       />
  //     </span>
  //   ),
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/state-list/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            <Menu.Item key="view">
              <Link to={`/city/${record._id}`}>View Cities</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCountry = (canEdit) => [
  // for the antD table headers
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country Name",
    dataIndex: "country_name",
    align: "center",
    key: "country_name_withoutspace",
  },
  {
    title: "Country Code",
    dataIndex: "country_code",
    align: "center",
    key: "country_code",
  },
  {
    title: "Country's Language",
    dataIndex: "country_language_name",
    key: "country_language_name",
    align: "center",
  },
  {
    title: "Language Code",
    dataIndex: "country_language_code",
    key: "country_language_code",
    align: "center",
  },
  {
    title: "Country's Currency",
    dataIndex: "country_currency",
    key: "country_currency",
    align: "center",
  },
  {
    title: "Currency's Symbol",
    dataIndex: "country_currency_symbol",
    key: "country_currency_symbol",
    align: "center",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/country/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            <Menu.Item key="view_states">
              <Link to={`/state-list/${record._id}`}>View States</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/country/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCity = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "city_name",
    key: "city_name",
  },
  {
    title: " Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (image) => {
      return image ? (
        <img
          src={image}
          alt="City"
          style={{
            width: 50,
            height: 50,
            objectFit: "cover",
            borderRadius: "20%",
          }}
        />
      ) : (
        <span style={{ color: "#aaa" }}>N/A</span>
      );
    },
  },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
    render: (business_type) => {
      if (!business_type || (Array.isArray(business_type) && business_type.length === 0)) {
        return "N/A";
      }
      const types = Array.isArray(business_type) ? business_type : [business_type];
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
          {types.map((type) => (
            <span
              key={type}
              style={{
                padding: "2px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 500,
                textTransform: "capitalize",
                background:
                  type === "fresh" ? "#ecfdf5" :
                    type === "resale" ? "#eff6ff" :
                      type === "business" ? "#fefce8" :
                        type === "rental" ? "#fdf4ff" : "#f3f4f6",
                color:
                  type === "fresh" ? "#059669" :
                    type === "resale" ? "#2563eb" :
                      type === "business" ? "#ca8a04" :
                        type === "rental" ? "#9333ea" : "#6b7280",
                border: `1px solid ${type === "fresh" ? "#a7f3d0" :
                  type === "resale" ? "#bfdbfe" :
                    type === "business" ? "#fde68a" :
                      type === "rental" ? "#e9d5ff" : "#e5e7eb"
                  }`,
              }}
            >
              {type}
            </span>
          ))}
        </div>
      );
    },
  },
  {
    title: "Vr Home Visit Available",
    align: "center",
    dataIndex: "is_vr_home_visit_available",
    key: "is_vr_home_visit_available",
    render: (is_vr_home_visit_available) => {
      return is_vr_home_visit_available ? (
        <span className="span-class-true">Available</span>
      ) : (
        <span className="span-class-false">Un-Available</span>
      );
    },
  },
  {
    title: "Popularity Status",
    align: "center",
    dataIndex: "is_popular",
    key: "is_popular",
    render: (popular) => {
      return popular ? (
        <span className="span-class-true">Popular</span>
      ) : (
        <span className="span-class-false">Non-Popular</span>
      );
    },
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", // Light gray border
  //         borderRadius: "10px", // Rounded edges
  //       }}
  //     >
  //       <Badge
  //         color={status === "active" ? "green" : "red"}
  //         text={status?.charAt(0).toUpperCase() + status?.slice(1)}
  //         background
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            {/* <Menu.Item key="View">
              <Link to={`/city/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/city/Edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAmenities = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Icon",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => {
      return <img src={record} alt="" style={{ maxWidth: "50px" }}></img>;
    },
  },
  {
    title: "Amenity For",
    align: "center",
    dataIndex: "amenities_for",
    key: "category",
    render: (amenity) => {
      return amenity.charAt(0).toUpperCase() + amenity.slice(1);
    },
  },
  {
    title: "Category",
    align: "center",
    dataIndex: "project_type",
    key: "project_type",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "Sub Category",
    align: "center",
    dataIndex: "category",
    key: "category",
    render: (category) =>
      Array.isArray(category) && category.length
        ? category.map((item) => item.charAt(0).toUpperCase() + item.slice(1)).join(", ")
        : "No Data",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link
                state={{ amenityName: record.name }}
                to={`/amenities/view/${record._id}`}
              >
                View
              </Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link
                  state={{ amenityName: record.name }}
                  to={`/amenities/edit/${record._id}`}
                >
                  Edit
                </Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              key="delete"
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/amenity/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsResaleAmenities = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: " Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Icon",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => {
      return <img src={record} alt="" style={{ maxWidth: "50px" }}></img>;
    },
  },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
    render: (business_type) => {
      if (!business_type || (Array.isArray(business_type) && business_type.length === 0)) {
        return "N/A";
      }
      const types = Array.isArray(business_type) ? business_type : [business_type];
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
          {types.map((type) => (
            <span
              key={type}
              style={{
                padding: "2px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 500,
                textTransform: "capitalize",
                background:
                  type === "fresh" ? "#ecfdf5" :
                    type === "resale" ? "#eff6ff" :
                      type === "business" ? "#fefce8" :
                        type === "rental" ? "#fdf4ff" : "#f3f4f6",
                color:
                  type === "fresh" ? "#059669" :
                    type === "resale" ? "#2563eb" :
                      type === "business" ? "#ca8a04" :
                        type === "rental" ? "#9333ea" : "#6b7280",
                border: `1px solid ${type === "fresh" ? "#a7f3d0" :
                  type === "resale" ? "#bfdbfe" :
                    type === "business" ? "#fde68a" :
                      type === "rental" ? "#e9d5ff" : "#e5e7eb"
                  }`,
              }}
            >
              {type}
            </span>
          ))}
        </div>
      );
    },
  },
  {
    title: "Amenity For",
    align: "center",
    dataIndex: "amenities_for",
    key: "category",
    render: (amenity) => {
      return amenity.charAt(0).toUpperCase() + amenity.slice(1);
    },
  },
  {
    title: "Category",
    align: "center",
    dataIndex: "project_type",
    key: "project_type",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "Sub Category",
    align: "center",
    dataIndex: "category",
    key: "category",
    render: (category) =>
      Array.isArray(category) && category.length
        ? category.map((item) => item.charAt(0).toUpperCase() + item.slice(1)).join(", ")
        : "No Data",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link
                state={{ amenityName: record.name }}
                to={`/amenities_resale/view/${record._id}`}
              >
                View
              </Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link
                  state={{ amenityName: record.name }}
                  to={`/amenities_resale/edit/${record._id}`}
                >
                  Edit
                </Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              key="delete"
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/amenity/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBuilders = [
  { title: "Sr No.", render: (_, __, index) => index + 1 },
  {
    title: "Builder Name",
    align: "center",
    dataIndex: "brand_name",
    key: "brand_name",
  },
  {
    title: "Type",
    align: "center",
    key: "business_type",
    dataIndex: "business_type",
  },
  {
    title: "Email Address",
    align: "center",
    key: "primary_email",
    dataIndex: "primary_email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "primary_contact_number",
    dataIndex: "primary_contact_number",
  },
  {
    title: "Builder ID",
    align: "center",
    key: "builder_id",
    dataIndex: "builder_id",
  },
  {
    title: "Authorised Person",
    align: "center",
    key: "authorized_persons",
    dataIndex: "authorized_persons",
    render: (authorized_persons) =>
      authorized_persons.length > 0
        ? authorized_persons.map((person) => person.name).join(", ")
        : "Not Available",
  },
  {
    title: "Total Projects",
    align: "center",
    dataIndex: "total_projects",
  },
  {
    title: "Live Projects",
    align: "center",
    dataIndex: "live_projects",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (account_status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={account_status === "approved" ? "green" : "red"}
          text={
            account_status?.charAt(0)?.toUpperCase() + account_status?.slice(1)
          }
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    dataIndex: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/builders/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];


export const columnsBuildersResale = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Image",
    dataIndex: "brand_logo",
    align: "center",
    key: "brand_logo",
    render: (text) => (
      <img
        src={text}
        alt="item"
        style={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: "8px", background: "#8080808f" }}
      />
    ),
  },
  {
    title: "Type",
    align: "center",
    key: "business_type",
    dataIndex: "business_type",
  },
  {
    title: "Builder Name",
    align: "center",
    dataIndex: "brand_name",
    key: "brand_name",
  },
  {
    title: "Builder ID",
    align: "center",
    key: "builder_id",
    dataIndex: "builder_id",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (account_status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={account_status === "approved" ? "green" : "red"}
          text={
            account_status?.charAt(0)?.toUpperCase() + account_status?.slice(1)
          }
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    dataIndex: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/builder_resale/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
            <Menu.Item key="edit">Edit
              <Link to={`/builder_resale/edit/${record._id}`} />
            </Menu.Item>
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsKiosk = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Kiosk ID",
    align: "center",
    key: "builder_id",
    dataIndex: "builder_id",
  },
  {
    title: "Organization Name",
    align: "center",
    dataIndex: "organization_name",
    key: "organization_name",
  },
  {
    title: "Email Address",
    align: "center",
    key: "primary_email",
    dataIndex: "primary_email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "primary_contact_number",
    render: (_, record) =>
      record
        ? `${record.primary_country_code || ""} ${record.primary_contact_number || ""}`.trim()
        : "N/A",
  },
  // {
  //   title: "Authorised Person",
  //   align: "center",
  //   key: "authorized_persons",
  //   dataIndex: "authorized_persons",
  //   render: (authorized_persons) =>
  //     authorized_persons.length > 0
  //       ? authorized_persons.map((person) => person.name).join(", ")
  //       : "Not Available",
  // },
  // {
  //   title: "Total Projects",
  //   align: "center",
  //   dataIndex: "total_projects",
  // },
  // {
  //   title: "Live Projects",
  //   align: "center",
  //   dataIndex: "live_projects",
  // },
  {
    title: "Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (account_status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            account_status === "approved"
              ? "green"
              : account_status === "requested"
                ? "orange"
                : "red"
          }
          text={
            account_status?.charAt(0)?.toUpperCase() + account_status?.slice(1)
          }
          background
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    dataIndex: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/kiosk/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsLeads = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    key: "name",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "Lead Source",
    align: "center",
    key: "lead_source",
    dataIndex: "lead_source",
    render: (val) => (val ? ToFirstCapital(val.replace(/_/g, " ")) : "—"),
  },
  {
    title: "Lead For",
    align: "center",
    key: "lead_for",
    dataIndex: "lead_for",
    render: (val) => (val ? ToFirstCapital(val.replace(/_/g, " ")) : "—"),
  },
  {
    title: "Contact",
    align: "center",
    key: "contact_number",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>
          {record?.country_code && record?.contact_number
            ? `${record.country_code} ${record.contact_number}`
            : record?.contact_number || "—"}
        </div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.country?.country_name || "—"}</div>
      </div>
    ),
  },
  {
    title: "Address",
    align: "center",
    key: "address",
    dataIndex: "address",
    width: 220,
    render: (val) =>
      val?.address ? (
        <Tooltip
          title={
            <div>
              <div>{val.address}</div>
              {val.house_flat_floorno && <div>House/Flat/Floor: {val.house_flat_floorno}</div>}
              {val.appartment_road_area && <div>Area: {val.appartment_road_area}</div>}
              {val.business_type && <div>Business Type: {val.business_type}</div>}
              {val.direction_to_reach && <div>Direction: {val.direction_to_reach}</div>}
            </div>
          }
        >
          <div style={{ maxWidth: 220, margin: "0 auto" }}>
            <div
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                lineHeight: 1.4,
              }}
            >
              {val.address}
            </div>
            {val.house_flat_floorno && (
              <div style={{ fontSize: 12, color: "#888" }}>{val.house_flat_floorno}</div>
            )}
          </div>
        </Tooltip>
      ) : (
        "—"
      ),
  },
  // {
  //   title: "Reason",
  //   align: "center",
  //   key: "reason",
  //   dataIndex: "reason",
  //   render: (val) => val || "—",
  // },
  // {
  //   title: "Partner",
  //   align: "center",
  //   key: "partner",
  //   render: (_, record) => (
  //     <div>
  //       <div style={{ fontWeight: 600 }}>{record?.partner?.name || "—"}</div>
  //       <div style={{ fontSize: 12, color: "#888" }}>{record?.partner?.staff_id || "—"}</div>
  //     </div>
  //   ),
  // },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => {
      const config = {
        pending: { background: "#fffbeb", color: "#b45309", border: "#fde68a" }, // amber
        scheduled: { background: "#fdf2f8", color: "#be185d", border: "#fbcfe8" },
        interested: { background: "#f0fdf4", color: "#15803d", border: "#bbf7d0" }, // green
        not_interested: { background: "#fef2f2", color: "#b91c1c", border: "#fecaca" }, // red
        follow_up: { background: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" }, // blue
        missed_call: { background: "#fff7ed", color: "#c2410c", border: "#fed7aa" }, // orange
        broker: { background: "#fdf4ff", color: "#7e22ce", border: "#e9d5ff" }, // purple
        completed: { background: "#ecfeff", color: "#0e7490", border: "#a5f3fc" }, // teal
      };
      const c = config[status] || { background: "#f5f5f5", color: "#595959", border: "#d9d9d9" };
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 500,
            whiteSpace: "nowrap",
            background: c.background,
            color: c.color,
            border: `1px solid ${c.border}`,
          }}
        >
          {status ? ToFirstCapital(status.replace(/_/g, " ")) : "—"}
        </span>
      );
    },
  },
  {
    title: "Remark",
    align: "center",
    key: "remark",
    dataIndex: "remark",
    width: 200,
    render: (val) =>
      val ? (
        <Tooltip title={val}>
          <div
            style={{
              maxWidth: 200,
              margin: "0 auto",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {val}
          </div>
        </Tooltip>
      ) : (
        "—"
      ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/leads/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/leads/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsLocality = (currentPage, pageSize, handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "City",
    align: "center",
    key: "city_name",
    render: (_, record) => record.city?.city_name || "N/A",
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Major",
    align: "center",
    key: "is_major",
    dataIndex: "is_major",
    render: (is_major) => (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          borderRadius: "10px",
          backgroundColor: is_major ? "#f6ffed" : "#fafafa",
          border: `1px solid ${is_major ? "#b7eb8f" : "#d9d9d9"}`,
          color: is_major ? "#52c41a" : "#8c8c8c",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {is_major ? "Yes" : "No"}
      </div>
    ),
  },
  {
    title: "Short Address",
    align: "center",
    dataIndex: "short_address",
    key: "short_address",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Google Maps",
    align: "center",
    key: "google_url",
    render: (_, record) => (
      <a
        href={record.google_url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1890ff' }}
      >
        View Map
      </a>
    ),
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => {
      const isActive = status === "active";
      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            borderRadius: "10px",
            backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
            border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
            color: isActive ? "#52c41a" : "#ff4d4f",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
              marginRight: "6px",
            }}
          />
          {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
        </div>
      );
    },
  },
  // {
  //   title: "Created",
  //   align: "center",
  //   key: "created_at",
  //   render: (_, record) => 
  //     record.created_at ? new Date(record.created_at).toLocaleDateString() : "N/A",
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">View
              <Link to={`/locality/view/${record._id}`}></Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">Edit

                <Link to={`/locality/edit/${record._id}`}></Link>
              </Menu.Item>
            }
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
                style={{ color: "green" }}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
                style={{ color: "red" }}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button
          shape="square"
          icon={<EllipsisOutlined />}
        />
      </Dropdown >
    ),
  },
];


export const columnsCollections = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },

  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.image}
        key={index}
        style={{ maxHeight: "30px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="Icon"
      ></img>
    ),
  },
  {
    title: "3D Icon",
    dataIndex: "3dIcon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.three_d_icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="three_d_icon"
      ></img>
    ),
  },
  // {
  //   title: "Banner Title",
  //   dataIndex: "banner_title",
  //   key: "banner_title",
  //   align: "center",
  //   render: (text) => (text && text.trim() !== "" ? text : "N/A")
  // },
  // {
  //   title: "Banner Image",
  //   dataIndex: "banner_image",
  //   key: "data",
  //   align: "center",
  //   render: (_, record, index) => (
  //     <img
  //       src={record?.banner_image}
  //       key={index}
  //       style={{ maxHeight: "30px" }}
  //       alt="Icon"
  //     ></img>
  //   ),
  // },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/collections/view/${record._id}`}>View</Link>
            </Menu.Item>
            {(canEdit &&
              <Menu.Item key="edit">
                <Link to={`/collections/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
            {/* <Menu.Item
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
              key="delete"
              style={{ color: "red" }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];


export const columnsCollectionsResale = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },

  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Type",
    dataIndex: "business_type",
    align: "center",
    key: "business_type",
    render: (business_type) =>
      Array.isArray(business_type) && business_type.length > 0
        ? business_type.join(", ")
        : "N/A",
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.image}
        key={index}
        style={{ maxHeight: "30px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="Icon"
      ></img>
    ),
  },
  {
    title: "3D Icon",
    dataIndex: "3dIcon",
    key: "data",
    align: "center",
    render: (_, record, index) => (
      <img
        src={record?.three_d_icon}
        key={index}
        style={{ maxHeight: "30px" }}
        alt="three_d_icon"
      ></img>
    ),
  },
  // {
  //   title: "Banner Title",
  //   dataIndex: "banner_title",
  //   key: "banner_title",
  //   align: "center",
  //   render: (text) => (text && text.trim() !== "" ? text : "N/A")
  // },
  // {
  //   title: "Banner Image",
  //   dataIndex: "banner_image",
  //   key: "data",
  //   align: "center",
  //   render: (_, record, index) => (
  //     <img
  //       src={record?.banner_image}
  //       key={index}
  //       style={{ maxHeight: "30px" }}
  //       alt="Icon"
  //     ></img>
  //   ),
  // },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/collections/view/${record._id}`}>View</Link>
            </Menu.Item>
            {(canEdit &&
              <Menu.Item key="edit">
                <Link to={`/collections/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
            {/* <Menu.Item
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
              key="delete"
              style={{ color: "red" }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsSubCollections = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Sub Collections Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "icon",
    align: "center",
    render: (record) => (
      <img src={record} alt="" style={{ maxWidth: "50px" }} />
    ),
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "3D Icon",
    dataIndex: "three_d_icon",
    key: "three_d_icon",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={status?.charAt(0).toUpperCase() + status?.slice(1)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Link to={`/collections/view/${record._id}`}>
              <Menu.Item>View</Menu.Item>
            </Link> */}
            {(canEdit &&
              <Link to={`/collections/${record._id}/sub/edit`}>
                <Menu.Item>Edit</Menu.Item>
              </Link>
            )}
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsSubCollectionsResale = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Sub Collections Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Type",
    dataIndex: "business_type",
    align: "center",
    key: "business_type",
    render: (business_type) =>
      Array.isArray(business_type) && business_type.length > 0
        ? business_type.join(", ")
        : "N/A",
  },
  {
    title: "Icon",
    dataIndex: "icon",
    key: "icon",
    align: "center",
    render: (record) => (
      <img src={record} alt="" style={{ maxWidth: "50px" }} />
    ),
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "3D Icon",
    dataIndex: "three_d_icon",
    key: "three_d_icon",
    align: "center",
    render: (image) => <img src={image} alt="" style={{ maxWidth: "50px" }} />,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={status?.charAt(0).toUpperCase() + status?.slice(1)}
          background
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Link to={`/collections/view/${record._id}`}>
              <Menu.Item>View</Menu.Item>
            </Link> */}
            {(canEdit &&
              <Link to={`/collections/${record._id}/sub/edit`}>
                <Menu.Item>Edit</Menu.Item>
              </Link>
            )}
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("collection/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCoupons = (handleStatusChange, canEdit) => [
  {
    title: "Sr. No.",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Coupon Id",
    dataIndex: "code",
    align: "center",
    key: "country_name_withoutspace",
  },
  {
    title: "Used for",
    dataIndex: "use_for",
    align: "center",
    key: "use_for",
    render: (value) => value || "N/A",
  },
  {
    title: "Discount Type",
    dataIndex: "discount_type",
    align: "center",
    key: "discount_type",
    render: (text) => ToFirstCapital(text),
  },
  {
    title: "Coupon Value",
    dataIndex: "discounts",
    key: "coupon_value",
    align: "center",
    render: (_, record) => {
      const discounts = Array.isArray(record?.discounts)
        ? record.discounts
        : [];

      // Check discounts array FIRST — if populated, use it (per-unit values)
      if (discounts.length > 0) {
        const tooltipText = discounts
          .map((d) => {
            const dt = d.discount_type ? ToFirstCapital(d.discount_type) : "";
            const val = d.value ?? "";
            const symbol = d.discount_in === "percent" ? "%" : "₹";
            const upto =
              d.discount_type === "upto" && d.value_upto_show > 0
                ? ` (Upto ${d.value_upto_show})`
                : "";
            return `${d?.unit || "Unit"}: ${dt} ${val}${symbol}${upto}`;
          })
          .join(" | ");

        return (
          <Tooltip title={tooltipText}>
            <div>
              {discounts.map((d, i) => (
                <div key={i} style={{ marginBottom: "4px" }}>
                  <strong>{d?.unit || "Unit"}:</strong>{" "}
                  {d.discount_type ? ToFirstCapital(d.discount_type) : ""}{" "}
                  {d.value ?? ""}
                  {d.discount_in === "percent" ? "%" : "₹"}
                  {d.discount_type === "upto" && d.value_upto_show > 0 && (
                    <> (Upto {d.value_upto_show})</>
                  )}
                </div>
              ))}
            </div>
          </Tooltip>
        );
      }

      // discounts empty — fall back to root-level discount_type/value
      const dt = record.discount_type
        ? ToFirstCapital(record.discount_type)
        : "";
      const val = record.value ?? "";
      const symbol = record.discount_in === "percent" ? "%" : "₹";
      const upto =
        record.discount_type === "upto" && record.value_upto_show > 0
          ? ` (Upto ${record.value_upto_show})`
          : "";
      const tooltipText = `${dt} ${val}${symbol}${upto}`;

      return (
        <Tooltip title={tooltipText}>
          <div>
            {dt} {val}
            {symbol}
            {upto}
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "Project Name",
    dataIndex: "project",
    key: "project",
    align: "center",
    width: 150,
    render: (project) => {
      const name = project?.project_name || "-";
      return (
        <Tooltip title={name}>
          <span
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              verticalAlign: "bottom",
            }}
          >
            {name}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "No. of Usages",
    dataIndex: "no_of_usage",
    key: "no_of_usage",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateToLocale(text),
  },
  {
    title: "Valid From",
    dataIndex: "start_date",
    key: "start_date",
    align: "center",
    render: (text) => {
      const d = new Date(text);
      const date = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
      return date;
    },
  },
  {
    title: "Expiry Date",
    dataIndex: "end_date",
    key: "end_date",
    align: "center",
    render: (text) => {
      const d = new Date(text);
      const date = `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
      return date;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Primary Status",
    dataIndex: "set_primary",
    align: "center",
    key: "set_primary",
    render: (set_primary) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
          whiteSpace: "nowrap"
        }}
      >
        <Badge
          color={set_primary ? "blue" : "gray"}
          text={set_primary ? "Primary" : "Not Primary"}
        />
      </span>
    ),
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Show Active only if status is NOT active */}
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}

            {!record.set_primary && canEdit && (
              <Menu.Item
                key="Primary"
                onClick={() => handleStatusChange(record, "primary")}
              >
                Primary
              </Menu.Item>
            )}

            {record.set_primary && canEdit && (
              <Menu.Item
                key="Remove Primary"
                onClick={() => handleStatusChange(record, "remove-primary")}
              >
                Remove Primary
              </Menu.Item>
            )}
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/coupon/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsEvents = (canEdit) => [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Event Id",
    align: "center",
    dataIndex: "event_id",
  },
  {
    title: "Event Type",
    align: "center",
    dataIndex: "type",
    render: (record) => record?.toUpperCase(),
  },
  {
    title: "Event Name",
    align: "center",
    dataIndex: "event_name",
    key: "event_name", render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Start Date",
    align: "center",
    key: "start_date",
    dataIndex: "start_date",
  },
  {
    title: "Start Time",
    align: "center",
    key: "start_time",
    dataIndex: "start_time",
    render: (value) => (value ? value : "N/A"),
  },
  {
    title: "End Date",
    align: "center",
    key: "end_date",
    dataIndex: "end_date",
  },
  {
    title: "End Time",
    align: "center",
    dataIndex: "end_time",
    render: (value) => (value ? value : "N/A"),
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "active" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/event/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/event/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/event/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button
          shape="sqaure"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

export const columnsExperienceCenter = (handleStatusChange, canEdit) => [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Center Code",
    dataIndex: "center_code",
    key: "center_code",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Country",
    dataIndex: ["country", "name"],
    key: "country",
    render: (_, record) => record?.country?.country_name || "—",
  },
  {
    title: "State",
    dataIndex: ["state", "name"],
    key: "state",
    render: (_, record) => record?.state?.state_name || "—",
  },
  {
    title: "City",
    dataIndex: ["city", "name"],
    key: "city",
    render: (_, record) => record?.city?.city_name || "—",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <span>
        {type === "coming_soon" ? "Coming Soon" : type === "available" ? "Available" : "—"}
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span className={`lec-status-badge lec-status-badge--${String(status).toLowerCase()}`}>
        {status}
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/experience_center/view/${record._id}`}>View</Link>
            </Menu.Item>

            <Menu.Item key="edit">
              <Link to={`/experience_center/edit/${record._id}`}>
                Edit
              </Link>
            </Menu.Item>
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                style={{ color: "green" }}
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                style={{ color: "red" }}
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsExperienceCenterForm = (canEdit) => [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Experience Center",
    key: "experience_center",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.experience_center?.title || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.experience_center?.center_code || "—"}</div>
      </div>
    ),
  },
  {
    title: "Address",
    key: "address",
    render: (_, record) => (
      <Tooltip placement="top" title={record?.experience_center?.address}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {record?.experience_center?.address || "—"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "User",
    key: "user",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.user?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.user?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "User Input",
    key: "user_input",
    render: (_, record) => (
      <Tooltip placement="top" title={record?.user_input}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {record?.user_input || "—"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span className={`lec-status-badge lec-status-badge--${String(status).toLowerCase()}`}>
        {status}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/experience_center_form/view/${record._id}`}>View</Link>
            </Menu.Item>

            {/* {record.status !== "approved" && canEdit && (
              <Menu.Item
                key="approved"
                style={{ color: "green" }}
                onClick={() => handleStatusChange(record, "approved")}
              >
                Approve
              </Menu.Item>
            )}

            {record.status !== "rejected" && canEdit && (
              <Menu.Item
                key="rejected"
                style={{ color: "red" }}
                onClick={() => handleStatusChange(record, "rejected")}
              >
                Reject
              </Menu.Item>
            )} */}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsProjects = (handleToggleExclusivity) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_name",
  },
  {
    title: "Project Type",
    align: "center",
    dataIndex: "project_type",
    render: (record) => (record ? record.name : ""),
  },
  {
    title: "Location",
    align: "center",
    dataIndex: "street_address",
    ellipsis: true,
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Total Bookings",
    align: "center",
    dataIndex: "booking_count", // match the backend field
    key: "booking_count",
    render: (text) => text || 0, // just in case
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "approved" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Exclusivity",
    align: "center",
    dataIndex: "is_exclusive",
    render: (isExclusive, record) => (
      <Switch
        checked={!!isExclusive}
        onChange={(checked) => handleToggleExclusivity(record._id, checked)}
      />
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/manage_projects/view/${record._id}`}>View</Link>
            </Menu.Item>

            <Menu.Item key="View_catalogue">
              <Link to={`/manage_projects/view/catalogue/${record._id}`}>
                View Project Catalogue
              </Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

// export const columnsProjectResale = [
//   {
//     title: "Sr No.",
//     align: "center",
//     render: (_, __, index) => index + 1,
//   },
//   {
//     title: "Project ID",
//     align: "center",
//     dataIndex: "project_id",
//   },
//   {
//     title: "Project Name",
//     align: "center",
//     dataIndex: "project_name",
//   },
//   {
//     title: "Project Type",
//     align: "center",
//     dataIndex: "project_type",
//     render: (record) => (record ? record.name : ""),
//   },
//   {
//     title: "Builder",
//     align: "center",
//     dataIndex: "builder",
//     render: (record) => (record ? record.brand_name : "—"),
//   },
//   {
//     title: "City",
//     align: "center",
//     dataIndex: "city",
//     render: (record) => (record ? record.city_name : "—"),
//   },
//   {
//     title: "Construction Status",
//     align: "center",
//     dataIndex: "construction_status",
//     render: (text) => text ? ToFirstCapital(text) : "—",
//   },
//   // {
//   //   title: "Average Price",
//   //   align: "center",
//   //   dataIndex: "average_price",
//   //   render: (text) => text ? `₹${text}` : "—",
//   // },
//   {
//     title: "Added By",
//     align: "center",
//     dataIndex: "added_by",
//     render: (value) => {
//       const isAdmin = value === "admin";
//       return (
//         <span
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             padding: "4px 12px",
//             borderRadius: "20px",
//             fontSize: "12px",
//             fontWeight: 500,
//             background: isAdmin ? "#eff6ff" : "#f0fdf4",
//             color: isAdmin ? "#1d4ed8" : "#15803d",
//             border: `1px solid ${isAdmin ? "#bfdbfe" : "#bbf7d0"}`,
//           }}
//         >
//           {isAdmin ? "Admin" : "Reseller"}
//         </span>
//       );
//     },
//   },
//   {
//     title: "Upload Date",
//     align: "center",
//     dataIndex: "created_at",
//     render: (record) => DateToLocale(record),
//   },
//   {
//     title: "Status",
//     align: "center",
//     dataIndex: "status",
//     render: (status) => (
//       <span
//         style={{
//           display: "inline-flex",
//           alignItems: "center",
//           padding: "4px 8px",
//           border: "1px solid #d9d9d9",
//           borderRadius: "10px",
//         }}
//       >
//         <Badge
//           color={
//             status === "approved" || status === "published" ? "green" : "red"
//           }
//           text={ToFirstCapital(status)}
//         />
//       </span>
//     ),
//   },
//   {
//     title: "Action",
//     align: "center",
//     key: "action",
//     render: (_, record) => (
//       <Dropdown
//         trigger={["click"]}
//         overlay={
//           <Menu>
//             <Menu.Item key="view">
//               <Link to={`/resale_project/view/${record._id}`}>View</Link>
//             </Menu.Item>
//             <Menu.Item key="edit">
//               <Link to={`/resale_project/edit/${record._id}`}>Edit</Link>
//             </Menu.Item>
//           </Menu>
//         }
//       >
//         <Button shape="square" icon={<EllipsisOutlined />} />
//       </Dropdown>
//     ),
//   },
// ];

// const ReelCell = ({ record }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Dropdown
//         trigger={["click"]}
//         overlay={
//           <Menu>
//             <Menu.Item key="view">
//               <Link to={`/resale_project/view/${record._id}`}>View</Link>
//             </Menu.Item>
//             <Menu.Item key="edit">
//               <Link to={`/resale_project/edit/${record._id}`}>Edit</Link>
//             </Menu.Item>
//             <Menu.Item key="reel" onClick={() => {
//               setOpen(true);
//             }}>
//               Add Reel
//             </Menu.Item>
//           </Menu>
//         }
//       >
//         <Button shape="square" icon={<EllipsisOutlined />} />
//       </Dropdown>

//       {open && (
//         <VideoModalProject
//           projectId={record._id}
//           onClose={() => setOpen(false)}
//         />
//       )}
//     </>
//   );
// };

export const columnsProjectResale = (onPopularToggle) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_name",
  },
  {
    title: "Project Type",
    align: "center",
    dataIndex: "project_type",
    render: (record) => (record ? record.name : ""),
  },
  {
    title: "Builder",
    align: "center",
    dataIndex: "builder",
    render: (record) => (record ? record.brand_name : "—"),
  },
  {
    title: "City",
    align: "center",
    dataIndex: "city",
    render: (record) => (record ? record.city_name : "—"),
  },
  {
    title: "Construction Status",
    align: "center",
    dataIndex: "construction_status",
    render: (text) => (text ? ToFirstCapital(text) : "—"),
  },
  {
    title: "Added By",
    align: "center",
    dataIndex: "added_by",
    render: (value) => {
      const isAdmin = value === "admin";
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 500,
            background: isAdmin ? "#eff6ff" : "#f0fdf4",
            color: isAdmin ? "#1d4ed8" : "#15803d",
            border: `1px solid ${isAdmin ? "#bfdbfe" : "#bbf7d0"}`,
          }}
        >
          {isAdmin ? "Admin" : "Reseller"}
        </span>
      );
    },
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Popular",
    align: "center",
    dataIndex: "is_popular",
    render: (is_popular) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 500,
          background: is_popular ? "#fefce8" : "#f3f4f6",
          color: is_popular ? "#a16207" : "#6b7280",
          border: `1px solid ${is_popular ? "#fde68a" : "#e5e7eb"}`,
        }}
      >
        {is_popular ? "⭐ Popular" : "Not Popular"}
      </span>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "approved" || status === "published" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => (
      <ActionCellProject record={record} onPopularToggle={onPopularToggle} />
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => {
  //     return <ReelCell record={record} />;
  //   },
  // },
];

export const columnsInterestedProjectResale = (handleStatusUpdate, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    render: (_, record) => record?.project?.project_id || "—",
  },
  {
    title: "Project Name",
    align: "center",
    render: (_, record) => record?.project?.project_name || "—",
  },
  {
    title: "User ID",
    align: "center",
    render: (_, record) => record?.user?.user_id || "—",
  },
  {
    title: "User Name",
    align: "center",
    render: (_, record) => record?.user?.name || "—",
  },
  {
    title: "Email",
    align: "center",
    render: (_, record) => record?.user?.email || "—",
  },
  {
    title: "Contact Number",
    align: "center",
    render: (_, record) => record?.user?.contact_number || "—",
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "closed"
              ? "green"
              : status === "ongoing"
                ? "blue"
                : status === "cancelled"
                  ? "red"
                  : "gold"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            ...(canEdit
              ? [
                {
                  key: "pending",
                  label: <span onClick={() => handleStatusUpdate(record?._id, "pending")}>Pending</span>,
                },
                {
                  key: "ongoing",
                  label: <span onClick={() => handleStatusUpdate(record?._id, "ongoing")}>Ongoing</span>,
                },
                {
                  key: "closed",
                  label: <span onClick={() => handleStatusUpdate(record?._id, "closed")}>Closed</span>,
                },
                {
                  key: "cancelled",
                  label: <span onClick={() => handleStatusUpdate(record?._id, "cancelled")}>Cancelled</span>,
                },
              ]
              : []),
          ],
        }}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsInterestedPropertyResale = (handleStatusUpdate, canEdit, businessType) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Property ID",
    align: "center",
    render: (_, record) => record?.property?.property_id || "—",
  },
  {
    title: "Property Name",           // ✅ New column
    align: "center",
    render: (_, record) => record?.property?.property_name || "—",
  },
  // ✅ Hidden when businessType === "business"
  ...(businessType !== "business" ? [
    {
      title: "Project ID",
      align: "center",
      render: (_, record) => record?.project?.project_id || "—",
    },
    {
      title: "Project Name",
      align: "center",
      render: (_, record) => record?.project?.project_name || "Not Assigned",
    },
  ] : []),
  {
    title: "Property Location",
    align: "center",
    render: (_, record) => record?.property?.property_location || "—",
  },
  {
    title: "Street Address",
    align: "center",
    render: (_, record) => record?.property?.street_address || "—",
  },
  {
    title: "User ID",
    align: "center",
    render: (_, record) => record?.user?.user_id || "—",
  },
  {
    title: "User Name",
    align: "center",
    render: (_, record) => record?.user?.name || "—",
  },
  {
    title: "Email",
    align: "center",
    render: (_, record) => record?.user?.email || "—",
  },
  {
    title: "Contact Number",
    align: "center",
    render: (_, record) => record?.user?.contact_number || "—",
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span style={{ display: "inline-flex", alignItems: "center", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "10px" }}>
        <Badge
          color={status === "closed" ? "green" : status === "ongoing" ? "blue" : status === "cancelled" ? "red" : "gold"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        menu={{
          items: [
            ...(canEdit ? [
              { key: "pending", label: <span onClick={() => handleStatusUpdate(record?._id, "pending")}>Pending</span> },
              { key: "ongoing", label: <span onClick={() => handleStatusUpdate(record?._id, "ongoing")}>Ongoing</span> },
              { key: "closed", label: <span onClick={() => handleStatusUpdate(record?._id, "closed")}>Closed</span> },
              { key: "cancelled", label: <span onClick={() => handleStatusUpdate(record?._id, "cancelled")}>Cancelled</span> },
            ] : []),
          ],
        }}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

const getDaysSince = (dateString) => {
  if (!dateString) return "-";
  const createdDate = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - createdDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const ReferralLists = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: ["booking", "booking_id"],
    render: (booking_id, record) => record.booking?.booking_id || "",
  },
  {
    title: "Referral From Name",
    align: "center",
    dataIndex: ["referral_from_user", "name"],
    render: (name, record) => record.referral_from_user?.name || "N/A",
  },
  {
    title: "Referral To Name",
    align: "center",
    dataIndex: ["referral_to_user", "name"],
    render: (name, record) => record.referral_to_user?.name || "N/A",
  },
  {
    title: "Referral Amount",
    align: "center",
    dataIndex: "referral_amount",
    ellipsis: true,
  },
  {
    title: "Created At Date",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (date, record) => DateToLocale(record.booking?.created_at),
  },
  {
    title: "Days Since Created",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (date) => {
      const days = getDaysSince(date);
      return days === 0 ? "Today" : `${days} day${days > 1 ? "s" : ""} ago`;
    },
  },
  {
    title: "Reward Days Left",
    align: "center",
    dataIndex: ["booking", "created_at"],
    render: (created_at) => {
      if (!created_at) return "";
      const rewardEndDate = new Date(created_at);
      rewardEndDate.setDate(rewardEndDate.getDate() + 45);

      const today = new Date();
      const diffTime = rewardEndDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays <= 0) return "Ended";
      if (diffDays === 1) return "1 day left";
      return `${diffDays} days left`;
    },
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => {
      const statusColors = {
        ongoing: "blue",
        paid: "green",
        closed: "gray",
        cancelled: "red",
      };
      const color = statusColors[status] || "default";
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge color={color} text={ToFirstCapital(status)} />
        </span>
      );
    },
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="View">
              <Link to={`/referrals/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const SignUpReferralLists = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
    render: (name) => name || "",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
    render: (email) => email || "",
  },
  {
    title: "User ID",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
    render: (id) => id || "",
  },
  {
    title: "Contact Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
    render: (_, record) =>
      record
        ? `${record.country_code || ""} ${record.contact_number || ""}`.trim()
        : "N/A",
  },
  {
    title: "Referred From ID",
    align: "center",
    dataIndex: "refer_from",
    key: "refer_from",
    render: (referFrom) => referFrom || "",
  },
  {
    title: "From Name",
    align: "center",
    key: "fromName",
    render: (_, record) => record.from?.name || "N/A",
  },
  {
    title: "From Email",
    align: "center",
    key: "fromEmail",
    render: (_, record) => record.from?.email || "N/A",
  },
  {
    title: "From Contact",
    align: "center",
    key: "fromContact",
    render: (_, record) =>
      record.from
        ? `${record.from.country_code || ""} ${record.from.contact_number || ""
          }`.trim()
        : "N/A",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (createdAt) => {
      if (!createdAt) return "";
      // Format the date string to locale if you want, e.g.:
      return new Date(createdAt).toLocaleDateString();
    },
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => {
  //     const statusColors = {
  //       ongoing: "blue",
  //       paid: "green",
  //       closed: "gray",
  //       cancelled: "red",
  //     };
  //     const color = statusColors[status] || "default";
  //     return (
  //       <span
  //         style={{
  //           display: "inline-flex",
  //           alignItems: "center",
  //           padding: "4px 8px",
  //           border: "1px solid #d9d9d9",
  //           borderRadius: "10px",
  //         }}
  //       >
  //         <Badge color={color} text={ToFirstCapital(status)} />
  //       </span>
  //     );
  //   },
  // },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => (
  //     <Dropdown
  //       trigger={["click"]}
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="View">
  //             <Link to={`/referrals/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsReferralCommission = (handleStatusChange, canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country",
    align: "center",
    dataIndex: "country",
    key: "country",
    render: (country) => (country && country.country_name) || "N/A",
  },
  {
    title: "State",
    align: "center",
    dataIndex: "state",
    key: "state",
    render: (state) => (state && state.state_name) || "N/A",
  },
  {
    title: "City",
    align: "center",
    dataIndex: "city",
    key: "city",
    render: (city) => (city && city.city_name) || "N/A",
  },
  {
    title: "Unit",
    align: "center",
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: "Referral Amount",
    align: "center",
    dataIndex: "referral_amount",
    key: "referral_amount",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => new Date(date).toLocaleDateString(),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Link to={`/referral_commission/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
            {/* Add Edit or Delete if needed */}
            {/* Show Active only if status is NOT active */}
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {/* Show Inactive only if status is NOT inactive */}
            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
            {canEdit &&
              <Link to={`/referral_commission/edit/${record._id}`}>
                <Menu.Item key="edit">Edit</Menu.Item>
              </Link>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsFranchise = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Franchise ID",
    dataIndex: "franchise_id",
    key: "franchise_id",
    align: "center",
  },
  {
    title: "Brand Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
  },
  {
    title: "Organization Name",
    dataIndex: "organization_name",
    key: "organization_name",
    align: "center",
  },
  {
    title: "Primary Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
  },
  {
    title: "Contact Number",
    key: "primary_contact_number",
    align: "center",
    render: (_, record) =>
      `${record.primary_country_code || ""} ${record.primary_contact_number || ""
      }`,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "approved"
              ? "green"
              : status === "rejected"
                ? "red"
                : "gray"
          }
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/franchise/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="assign_builder">
              <Link to={`/franchise/assign-builder/${record._id}`}>
                Builder List
              </Link>
            </Menu.Item>
            <Menu.Item key="assign_builder_list">
              <Link to={`/franchise/assign-builder-list/${record._id}`}>
                Assigned Builder
              </Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsRewards = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Voucher",
    dataIndex: "voucher",
    key: "voucher",
    align: "center",
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  // {
  //   title: "Logo",
  //   dataIndex: "logo",
  //   key: "logo",
  //   align: "center",
  //   render: (logo) =>
  //     logo ? <img src={logo} alt="Logo" style={{ width: 50, height: 50 }} /> : "N/A",
  // },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) =>
      image ? (
        <img src={image} alt="Voucher" style={{ width: 50, height: 50, borderRadius: "20%" }} />
      ) : (
        "N/A"
      ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Primary Status",
    dataIndex: "primary",
    align: "center",
    key: "primary",
    render: (set_primary) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={set_primary ? "blue" : "gray"} // ✅ show primary in blue, not primary in gray
          text={set_primary ? "Primary" : "Not Primary"} // ✅ show label
        />
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "active"
              ? "green"
              : status === "inactive"
                ? "red"
                : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/rewards_voucher/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/rewards_voucher/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* If you have other relevant links for action, add here */}
            {
              record.status !== "active" && canEdit && (
                <Menu.Item
                  key="Active"
                  onClick={() => handleStatusChange(record, "active")}
                >
                  Active
                </Menu.Item>
              )
            }
            {/* Show Inactive only if status is NOT inactive */}

            {
              record.status !== "inactive" && canEdit && (
                <Menu.Item
                  key="Inactive"
                  onClick={() => handleStatusChange(record, "inactive")}
                >
                  Inactive
                </Menu.Item>
              )
            }

            {!record.primary && canEdit && (
              <Menu.Item
                key="Primary"
                onClick={() => handleStatusChange(record, "primary")}
              >
                Primary
              </Menu.Item>
            )}

            {record.primary && canEdit && (
              <Menu.Item
                key="Remove Primary"
                onClick={() => handleStatusChange(record, "remove-primary")}
              >
                Remove Primary
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsPage = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (value) =>
      value
        ? value
          .split("_")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(" ")
        : "N/A",
  },
  {
    title: "Page Name",
    dataIndex: "pageName",
    key: "pageName",
    align: "center",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "PDF URL",
    dataIndex: "pdf_url",
    key: "pdf_url",
    align: "center",
    render: (url) =>
      url ? (
        <a href={url} target="_blank" rel="noreferrer">
          View PDF
        </a>
      ) : (
        "N/A"
      ),
  },
  {
    title: "Current Version",
    dataIndex: "curr_version",
    key: "curr_version",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/pages/view/${record.type}`}>View</Link>
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit">
                <Link to={`/pages/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRewardsPoints = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Minimum Value",
    dataIndex: "min_value",
    render: (val) => val ?? "N/A",
    align: "center",
  },
  {
    title: "Maximum Value",
    dataIndex: "max_value",
    key: "max_value",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   align: "center",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={status === "active" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       />
  //     </span>
  //   ),
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* If you have a view page for reward points, adjust link accordingly */}
            {/* <Menu.Item key="view">
              <Link to={`/reward-points/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/rewards_point/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* {record.status !== "active" && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}
            {record.status !== "inactive" && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )} */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsRewardCoupon = (handleStatusChange) => [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Coupon Code",
    key: "code",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.code || "—"}</div>
      </div>
    ),
  },
  {
    title: "Agent",
    key: "agent",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.agent?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.agent?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "No of Usage",
    dataIndex: "no_of_usage",
    key: "no_of_usage",
    align: "center",
    render: (val) => val ?? "—",
  },
  // {
  //   title: "Min Price",
  //   dataIndex: "min_price",
  //   key: "min_price",
  //   align: "center",
  //   render: (val) => val ? `₹${val}` : "—",
  // },
  {
    title: "Reward Points",
    dataIndex: "reward_point",
    key: "reward_point",
    align: "center",
    render: (val) => val ?? "—",
  },
  // {
  //   title: "Start Date",
  //   dataIndex: "start_date",
  //   key: "start_date",
  //   render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  // },
  // {
  //   title: "End Date",
  //   dataIndex: "end_date",
  //   key: "end_date",
  //   render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  // },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span className={`lrc-status-badge lrc-status-badge--${String(status).toLowerCase()}`}>
        {status}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/reward_coupon/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/reward_coupon/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {record.status === "active" && (
              <Menu.Item
                key="deactivate"
                style={{ color: "red" }}
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
            {record.status === "inactive" && (
              <Menu.Item
                key="activate"
                style={{ color: "green" }}
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsContactUs = [
  {
    title: "Sr. No",
    align: "center",
    key: "sr_no",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    key: "name",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "Phone Number",
    dataIndex: "phone_number",
    key: "phone_number",
    align: "center",
    render: (val) => val || "—",
  },
  {
    title: "Message",
    key: "message",
    render: (_, record) => (
      <Tooltip placement="top" title={record?.message}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {record?.message || "—"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "User",
    key: "user",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.user?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.user?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) =>
      date
        ? new Date(date).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        : "—",
  },
];

export const columnsEmailList = (currentPage, pageSize, handleDelete, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
                Delete
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsOoraList = (currentPage, pageSize, handleDelete, openEditModal, canEdit) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      key: "plan_name",
      align: "center",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      render: (amount, record) => (
        <>
          {record.currency} {amount}
          {record.before_discount_amount && (
            <span style={{ textDecoration: "line-through", marginLeft: "5px", color: "#999" }}>
              {record.currency} {record.before_discount_amount}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      align: "center",
    },
    {
      title: "Most Popular",
      dataIndex: "is_most_popular",
      key: "is_most_popular",
      align: "center",
      render: (isMostPopular) => (
        <span style={{ color: isMostPopular ? "#1890ff" : "#999" }}>
          {isMostPopular ? "⭐ Yes" : "No"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const isActive = status === "active";
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
              border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
              color: isActive ? "#52c41a" : "#ff4d4f",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                marginRight: "6px",
              }}
            />
            {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
          </div>
        );
      },
    },
  ];

  // Conditionally add Action column only if canEdit is true
  const columns = [...baseColumns];

  if (canEdit) {
    columns.push({
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
              <Menu.Item
                key="status"
                onClick={() => handleDelete(record._id)}
                style={{ color: record.status === "active" ? "#ff4d4f" : "#52c41a" }}
              >
                {record.status === "active" ? "Deactivate" : "Activate"}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnsPropertyResaleVibeList = (
  currentPage,
  pageSize,
  handleStatusUpdate,
  openEditModal,
  canEdit
) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (name) => name || "-",
    },
    {
      title: "Parent Category",
      dataIndex: "parent_category",
      key: "parent_category",
      align: "center",
      render: (name) => name || "-",
    },
    {
      title: "Category Type",
      dataIndex: "category_name",
      key: "category_name",
      align: "center",
      render: (name) => name || "-",
    },
    {
      title: "Icon",
      dataIndex: "icon",
      key: "icon",
      align: "center",
      render: (icon) => (
        icon ? (
          <img
            src={icon}
            alt="Vibe icon"
            style={{ borderRadius: "50px", width: "50px", height: "50px" }}
          />
        ) : (
          "-"
        )
      ),
    },
    {
      title: "Business Type",
      dataIndex: "business_type",
      key: "business_type",
      align: "center",
      render: (business_type) => {
        if (!business_type || (Array.isArray(business_type) && business_type.length === 0)) {
          return "N/A";
        }
        const types = Array.isArray(business_type) ? business_type : [business_type];
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
            {types.map((type) => (
              <span
                key={type}
                style={{
                  padding: "2px 10px",
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 500,
                  textTransform: "capitalize",
                  background:
                    type === "fresh" ? "#ecfdf5" :
                      type === "resale" ? "#eff6ff" :
                        type === "business" ? "#fefce8" :
                          type === "rental" ? "#fdf4ff" : "#f3f4f6",
                  color:
                    type === "fresh" ? "#059669" :
                      type === "resale" ? "#2563eb" :
                        type === "business" ? "#ca8a04" :
                          type === "rental" ? "#9333ea" : "#6b7280",
                  border: `1px solid ${type === "fresh" ? "#a7f3d0" :
                    type === "resale" ? "#bfdbfe" :
                      type === "business" ? "#fde68a" :
                        type === "rental" ? "#e9d5ff" : "#e5e7eb"
                    }`,
                }}
              >
                {type}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => text ? new Date(text).toLocaleDateString() : "-",
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const isActive = status === "active";
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
              border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
              color: isActive ? "#52c41a" : "#ff4d4f",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                marginRight: "6px",
              }}
            />
            {status ? status.charAt(0).toUpperCase() + status.slice(1) : "-"}
          </div>
        );
      },
    },
  ];

  // Conditionally add Action column only if canEdit is true
  const columns = [...baseColumns];

  if (canEdit) {
    columns.push({
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
              <Menu.Item
                key="status"
                onClick={() => handleStatusUpdate(record._id)}
                style={{ color: record.status === "active" ? "#ff4d4f" : "#52c41a" }}
              >
                {record.status === "active" ? "Inactive" : "Active"}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnsRentalList = (
  currentPage,
  pageSize,
  handleDelete,
  openEditModal,
  canEdit
) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      key: "plan_name",
      align: "center",
    },
    {
      title: "Amounts",
      dataIndex: "amounts",
      key: "amounts",
      align: "center",
      render: (amounts) => {
        if (!amounts?.length) return "-";
        const sorted = [...amounts].sort((a, b) => a.room - b.room);
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
            {sorted.map((entry) => (
              <div key={entry._id} style={{ fontSize: "12px" }}>
                <span style={{ fontWeight: 500 }}>{entry.room} Room:</span>{" "}
                {entry.currency} {entry.amount}
                {entry.before_discount_amount && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      marginLeft: "5px",
                      color: "#999",
                    }}
                  >
                    {entry.currency} {entry.before_discount_amount}
                  </span>
                )}
              </div>
            ))}
          </div>
        );
      },
    },
    // {
    //   title: "Features",
    //   dataIndex: "features",
    //   key: "features",
    //   align: "center",
    //   render: (features) => {
    //     if (!features?.length) return "-";
    //     return (
    //       <div style={{ display: "flex", flexDirection: "column", gap: "2px", alignItems: "flex-start" }}>
    //         {features.map(([name, enabled], idx) => (
    //           <span key={idx} style={{ fontSize: "12px", color: enabled ? "#52c41a" : "#999" }}>
    //             {enabled ? "✓" : "✗"} {name}
    //           </span>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Most Popular",
      dataIndex: "is_most_popular",
      key: "is_most_popular",
      align: "center",
      render: (isMostPopular) => (
        <span style={{ color: isMostPopular ? "#1890ff" : "#999" }}>
          {isMostPopular ? "⭐ Yes" : "No"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "-"),
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const isActive = status === "active";
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
              border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
              color: isActive ? "#52c41a" : "#ff4d4f",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                marginRight: "6px",
              }}
            />
            {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
          </div>
        );
      },
    },
  ];

  const columns = [...baseColumns];

  if (canEdit) {
    columns.push({
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
              <Menu.Item
                key="status"
                onClick={() => handleDelete(record._id)}
                style={{
                  color: record.status === "active" ? "#ff4d4f" : "#52c41a",
                }}
              >
                {record.status === "active" ? "Deactivate" : "Activate"}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnsVrShootRentalList = (
  currentPage,
  pageSize,
  handleDelete,
  openEditModal,
  canEdit
) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      align: "center",
      render: (category) => category?.name || category?.category_name || "-",
    },
    {
      title: "No. of Bedrooms",
      dataIndex: "no_of_bedroom",
      key: "no_of_bedroom",
      align: "center",
      render: (no_of_bedroom) => no_of_bedroom || "-",
    },
    {
      title: "Amount",
      key: "amount",
      align: "center",
      render: (_, record) => (
        <div style={{ fontSize: "12px" }}>
          <span style={{ fontWeight: 500 }}>₹{record.amount}</span>
          {record.cutPrice && (
            <span
              style={{
                textDecoration: "line-through",
                marginLeft: "6px",
                color: "#999",
              }}
            >
              ₹{record.cutPrice}
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "-"),
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const isActive = status === "active";
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
              border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
              color: isActive ? "#52c41a" : "#ff4d4f",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                marginRight: "6px",
              }}
            />
            {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
          </div>
        );
      },
    },
  ];

  const columns = [...baseColumns];

  if (canEdit) {
    columns.push({
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
              <Menu.Item
                key="delete"
                danger
                onClick={() => handleDelete(record._id)}
              >
                Delete
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnsCorporateRentalDiscountList = (
  currentPage,
  pageSize,
  handleStatusToggle,
  openEditModal,
  canEdit
) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Domain",
      dataIndex: "domain_name",
      key: "domain_name",
      align: "center",
    },
    {
      title: "Discount Type",
      dataIndex: "discount_type",
      key: "discount_type",
      align: "center",
      render: (type) => (type ? type.charAt(0).toUpperCase() + type.slice(1) : "-"),
    },
    {
      title: "Value",
      key: "value",
      align: "center",
      render: (_, record) => (
        <div style={{ fontSize: "12px" }}>
          {record.discount_type === "amount" ? (
            <span style={{ fontWeight: 500 }}>
              {record.currency || ""} {record.discount_amount ?? "-"}
            </span>
          ) : (
            <span style={{ fontWeight: 500 }}>{record.reward_credit ?? "-"} credits</span>
          )}
        </div>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "-"),
    },
    {
      title: "Status",
      align: "center",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        const isActive = status === "active";
        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isActive ? "#f6ffed" : "#fff2f0",
              border: `1px solid ${isActive ? "#b7eb8f" : "#ffccc7"}`,
              color: isActive ? "#52c41a" : "#ff4d4f",
              fontSize: "12px",
              fontWeight: 500,
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#52c41a" : "#ff4d4f",
                marginRight: "6px",
              }}
            />
            {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
          </div>
        );
      },
    },
  ];

  const columns = [...baseColumns];

  if (canEdit) {
    columns.push({
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
              <Menu.Item
                key="status"
                onClick={() => handleStatusToggle(record)}
              >
                {record.status === "active" ? "Mark Inactive" : "Mark Active"}
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return columns;
};

export const columnsOoraPaymentList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Payment ID",
    dataIndex: "payment_id",
    key: "payment_id",
    align: "center",
    ellipsis: true,
    render: (paymentId, record) => {
      const orderId = record.report_plan?.order?.entity?.id || "N/A";
      return (
        <div>
          <div style={{ fontWeight: 600, color: "#1890ff" }}>
            {orderId}
          </div>
          {paymentId && (
            <div style={{ fontSize: "12px", color: "#666" }}>
              {paymentId}
            </div>
          )}
        </div>
      );
    },
    sorter: (a, b) => {
      const aOrder = a.report_plan?.order?.entity?.id || "";
      const bOrder = b.report_plan?.order?.entity?.id || "";
      return aOrder.localeCompare(bOrder);
    },
  },
  {
    title: "User",
    dataIndex: "user_name",
    key: "user_name",
    align: "center",
  },
  {
    title: "Contact Number",
    dataIndex: "user_phone",
    key: "user_phone",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "user_email",
    key: "user_email",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    render: (amount, record) => (
      <strong>
        {record.currency} {amount?.toLocaleString()}
      </strong>
    ),
    sorter: (a, b) => a.amount - b.amount,
  },
  {
    title: "Payment Type",
    dataIndex: "payment_type",
    key: "payment_type",
    align: "center",
    render: (_, record) => {
      const paymentMethod = record.report_plan?.order?.entity?.notes?.payment_method ||
        record.payment_type || "N/A";

      let color = "#1890ff", bgColor = "#e6f7ff";
      if (paymentMethod === "razorpay") {
        color = "#00b96b";
        bgColor = "#e6fffa";
      }

      return (
        <span
          style={{
            color,
            backgroundColor: bgColor,
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 600
          }}
        >
          {paymentMethod?.toUpperCase() || "N/A"}
        </span>
      );
    },
    filters: [
      { text: "RAZORPAY", value: "razorpay" },
      { text: "DEBIT", value: "debit" },
      { text: "CREDIT", value: "credit" },
    ],
    onFilter: (value, record) => {
      const method = record.report_plan?.order?.entity?.notes?.payment_method || record.payment_type;
      return method === value;
    },
  },
  {
    title: "Status",
    dataIndex: "payment_status",
    key: "payment_status",
    align: "center",
    render: (status) => (
      <span
        style={{
          color: status === "completed" ? "#52c41a" : status === "failed" ? "#ff4d4f" : "#faad14",
          backgroundColor: status === "completed" ? "#f6ffed" : status === "failed" ? "#fff2f0" : "#fffbe6",
          padding: "4px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: 600
        }}
      >
        {status?.toUpperCase() || "PENDING"}
      </span>
    ),
    filters: [
      { text: "COMPLETED", value: "completed" },
      { text: "FAILED", value: "failed" },
      { text: "PENDING", value: "pending" },
    ],
    onFilter: (value, record) => record.payment_status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
  },
];



export const columnsCommingSoonCitiesList = (currentPage, pageSize, handleDelete, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "City Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Image",
    dataIndex: "url",
    key: "url",
    align: "center",
    render: (image) => image ? (
      <img
        src={image}
        alt="Review"
        style={{
          width: 50,
          height: 50,
          borderRadius: "20%",
          objectFit: 'contain',
          border: '1px solid #e0e0e0'
        }}
      />
    ) : (
      <span style={{ color: '#999' }}>No Image</span>
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (text) => text?.substring(0, 50) + (text?.length > 50 ? "..." : ""),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
                Delete
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];



export const columnsReviewRatingList = (currentPage, pageSize, openViewModal, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (text) => {
      if (!text) return "-";
      const formatted = text.replace(/_/g, " ");
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    },
  },
  {
    title: "Profession",
    dataIndex: "profession",
    key: "profession",
    align: "center",
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
    align: "center",
    render: (rating) => {
      const filledStars = Math.floor(rating || 0);

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {[...Array(filledStars)].map((_, i) => (
            <span
              key={`filled-${i}`}
              style={{
                color: "#ffa500",
                fontSize: '20px'
              }}
            >
              ⭐
            </span>
          ))}

          {/* Empty Stars */}
          {[...Array(5 - filledStars)].map((_, i) => (
            <span
              key={`empty-${i}`}
              style={{
                color: "#ccc",
                fontSize: '20px'
              }}
            >
              ☆
            </span>
          ))}

          {/* <span style={{ marginLeft: 8, fontSize: 14, color: "#666" }}>
            ({rating})
          </span> */}
        </div>
      );
    },
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "Image",
    dataIndex: "image",
    key: "image",
    align: "center",
    render: (image) => image ? (
      <img
        src={image}
        alt="Review"
        style={{
          width: 50,
          height: 50,
          borderRadius: "20%",
          objectFit: 'contain',
          border: '1px solid #e0e0e0'
        }}
      />
    ) : (
      <span style={{ color: '#999' }}>No Image</span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="view"
              onClick={() => openViewModal(record)}
            >
              View
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsHomeBannerList = (currentPage, pageSize, handleStatusChange, openViewModal, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (type) => (
      <span
        style={{
          background: "#f0f4ff",
          color: "#0D1A52",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          textTransform: "capitalize",
        }}
      >
        {type || "—"}
      </span>
    ),
  },
  {
    title: "Thumbnail",
    dataIndex: "thumbnail",
    key: "thumbnail",
    align: "center",
    render: (image) =>
      image ? (
        <img
          src={image}
          alt="Banner"
          style={{
            width: 60,
            height: 40,
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #e0e0e0",
          }}
        />
      ) : (
        <span style={{ color: "#999" }}>No Thumbnail</span>
      ),
  },
  // {
  //   title: "Image",
  //   dataIndex: "home_image",
  //   key: "home_image",
  //   align: "center",
  //   render: (image) =>
  //     image ? (
  //       <img
  //         src={image}
  //         alt="Banner"
  //         style={{
  //           width: 60,
  //           height: 40,
  //           borderRadius: "8px",
  //           objectFit: "cover",
  //           border: "1px solid #e0e0e0",
  //         }}
  //       />
  //     ) : (
  //       <span style={{ color: "#999" }}>No Image</span>
  //     ),
  // },
  {
    title: "Video",
    dataIndex: "home_videos",
    key: "home_videos",
    align: "center",
    render: (video) =>
      video ? (
        <a href={video} target="_blank" rel="noreferrer" style={{ color: "#0D1A52" }}>
          View
        </a>
      ) : (
        <span style={{ color: "#999" }}>—</span>
      ),
  },
  {
    title: "Theme",
    dataIndex: "theme",
    key: "theme",
    align: "center",
  },
  {
    title: "Position",
    dataIndex: "position",
    key: "position",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span className={`lrc-status-badge lrc-status-badge--${String(status).toLowerCase()}`}>
        {status}
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => openViewModal(record)}>
              View
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            )}
            {record.status === "active" && (
              <Menu.Item
                key="deactivate"
                style={{ color: "red" }}
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
            {record.status === "inactive" && (
              <Menu.Item
                key="activate"
                style={{ color: "green" }}
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUserQueryProjectList = (currentPage, pageSize, openViewModal, openEditModal, handleDelete, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    key: "project_name",
    align: "center",
  },
  {
    title: "Builder Name",
    dataIndex: "builder_name",
    key: "builder_name",
    align: "center",
  },
  {
    title: "Street Address",
    dataIndex: "street_address",
    key: "street_address",
    align: "center",
    ellipsis: true,
  },
  {
    title: "User",
    dataIndex: "user",
    key: "user",
    align: "center",
    render: (user) => user?.name || "—",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => openViewModal(record)}>
              View
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            )}
            {canEdit && (
              <Menu.Item
                key="delete"
                style={{ color: "red" }}
                onClick={() => handleDelete(record)}
              >
                Delete
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

// Add this inside columnsAntd.js alongside your other column definitions

export const columnsFeaturedBusinessPropertyList = (currentPage, pageSize, openViewModal, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Property ID",
    dataIndex: "property",
    key: "property_id",
    align: "center",
    render: (property) => (
      <span
        style={{
          background: "#f0f4ff",
          color: "#0D1A52",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {property?.property_id || "—"}
      </span>
    ),
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    align: "center",
    render: (city) => city?.city_name || "—",
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    align: "center",
    render: (state) => state?.state_name || "—",
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
    align: "center",
    render: (country) => country?.country_name || "—",
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    render: (ranking) => ranking ?? "—",
  },
  {
    title: "Property Status",
    dataIndex: "property",
    key: "property_status",
    align: "center",
    render: (property) => {
      const status = property?.status;
      const colorMap = {
        published: { bg: "#e6f9f0", color: "#0a7c42" },
        unpublished: { bg: "#fff7e6", color: "#b45309" },
        draft: { bg: "#f0f4ff", color: "#0D1A52" },
      };
      const style = colorMap[status] || { bg: "#f5f5f5", color: "#333" };
      return status ? (
        <span style={{
          background: style.bg, color: style.color,
          padding: "3px 10px", borderRadius: "12px",
          fontSize: "12px", fontWeight: 500, textTransform: "capitalize",
        }}>
          {status}
        </span>
      ) : "—";
    },
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => (text ? new Date(text).toLocaleDateString() : "—"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => openViewModal(record)}>
              View
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsHomeVrList = (currentPage, pageSize, openViewModal, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Project Name",
    dataIndex: ["project_data", "project_name"],
    key: "project_name",
    align: "center",
    render: (name) => (
      <span
        style={{
          background: "#f0f4ff",
          color: "#0D1A52",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          textTransform: "capitalize",
        }}
      >
        {name || "—"}
      </span>
    ),
  },
  {
    title: "Project ID",
    dataIndex: ["project_data", "project_id"],
    key: "project_id",
    align: "center",
    render: (id) => (
      <span style={{ fontSize: "12px", color: "#6b7280", fontFamily: "monospace" }}>
        {id || "—"}
      </span>
    ),
  },
  {
    title: "Cover Photo",
    dataIndex: ["project_data", "cover_photo"],
    key: "cover_photo",
    align: "center",
    render: (image) =>
      image ? (
        <img
          src={image}
          alt="Cover"
          style={{
            width: 60,
            height: 40,
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #e0e0e0",
          }}
        />
      ) : (
        <span style={{ color: "#999" }}>No Image</span>
      ),
  },
  {
    title: "Project Ranking",
    dataIndex: "project_ranking",
    key: "project_ranking",
    align: "center",
    render: (rank) => (
      <span
        style={{
          background: "#f0f4ff",
          color: "#0D1A52",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
        }}
      >
        {rank ?? 0}
      </span>
    ),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => (text ? new Date(text).toLocaleDateString() : "—"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => openViewModal(record)}>
              View
            </Menu.Item>
            {canEdit && (
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAgentProfitRangeList = (currentPage, pageSize, handleDelete, openEditModal, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Profit Range (%)",
    dataIndex: "agent_profit_range",
    key: "agent_profit_range",
    align: "center",
    render: (value) => `${value}%`,
  },
  {
    title: "Min Price",
    dataIndex: "min_price",
    key: "min_price",
    align: "center",
    render: (value) => {
      const num = value || 0;
      if (num >= 10000000) {
        return `₹${(num / 10000000).toFixed(1)} Cr`;
      } else if (num >= 100000) {
        return `₹${(num / 100000).toFixed(1)} L`;
      }
      return `₹${num.toLocaleString()}`;
    },
  },
  {
    title: "Max Price",
    dataIndex: "max_price",
    key: "max_price",
    align: "center",
    render: (value) => {
      const num = value || 0;
      if (num >= 10000000) {
        return `₹${(num / 10000000).toFixed(1)} Cr`;
      } else if (num >= 100000) {
        return `₹${(num / 100000).toFixed(1)} L`;
      }
      return `₹${num.toLocaleString()}`;
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
    render: (value) => (
      <span style={{
        background: value === 'luxury' ? '#fff2e8' :
          value === 'premium' ? '#f9f0ff' :
            value === 'standard' ? '#f6ffed' :
              value === 'basic' ? '#e6f7ff' : '#f5f5f5',
        color: value === 'luxury' ? '#d46b08' :
          value === 'premium' ? '#722ed1' :
            value === 'standard' ? '#52c41a' :
              value === 'basic' ? '#1890ff' : '#000',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500
      }}>
        {value?.toUpperCase() || 'N/A'}
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit" onClick={() => openEditModal(record)}>
                Edit
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item key="delete" onClick={() => handleDelete(record._id)} style={{ color: "red" }}>
                Delete
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRewardsUserPoints = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Name",
    dataIndex: "name", // Note: Keep as per schema, consider fixing typo to contact_number in schema
    key: "name",
    align: "center",
  },
  {
    title: "Contact Number",
    dataIndex: "contact_number", // Note: Keep as per schema, consider fixing typo to contact_number in schema
    key: "contact_number",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    align: "center",
  },
  // {
  //   title: "Start Date",
  //   dataIndex: "start_at",
  //   key: "start_at",
  //   align: "center",
  //   render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  // },
  // {
  //   title: "Expiry Date",
  //   dataIndex: "expire_at",
  //   key: "expire_at",
  //   align: "center",
  //   render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  // },
  // {
  //   title: "Status",
  //   dataIndex: "status",
  //   key: "status",
  //   align: "center",
  //   render: (status) => (
  //     <Badge
  //       color={status === "active" ? "green" : "red"}
  //       text={ToFirstCapital(status)}
  //     />
  //   ),
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit">
              <Link to={`/rewards_user_point/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Status toggles can be re-enabled if needed */}
            {/* 
            {record.status !== "active" && (
              <Menu.Item key="Active" onClick={() => handleStatusChange(record, "active")}>
                Activate
              </Menu.Item>
            )}
            {record.status !== "inactive" && (
              <Menu.Item key="Inactive" onClick={() => handleStatusChange(record, "inactive")}>
                Deactivate
              </Menu.Item>
            )}
             */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsBuildersRanking = (currentPage, pageSize, handleUpdateRanking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.ranking || 999999) - (b.ranking || 999999),
  },
  {
    title: "Builder Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Organization",
    dataIndex: "organization_name",
    key: "organization_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Contact Number",
    dataIndex: "primary_contact_number",
    key: "primary_contact_number",
    align: "center",
  },
  {
    title: "Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "account_status",
    align: "center",
    render: (status) => (
      <span
        style={{
          color: status === "approved" ? "#52c41a" : "#faad14",
          backgroundColor: status === "approved" ? "#f6ffed" : "#fffbe6",
          padding: "2px 8px",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: 500
        }}
      >
        {status?.toUpperCase() || "N/A"}
      </span>
    ),
    filters: [
      { text: "Requested", value: "requested" },
      { text: "Approved", value: "approved" },
    ],
    onFilter: (value, record) => record.account_status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsProjectRanking = (currentPage, pageSize, handleUpdateRanking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.ranking || 999999) - (b.ranking || 999999),
  },
  {
    title: "Project ID",
    dataIndex: "project_id",
    key: "project_id",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    key: "project_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Project Type",
    dataIndex: "project_type",
    key: "project_type",
    align: "center",
    ellipsis: true,
    render: (project_type) => project_type?.name || "N/A",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => {
      const statusLower = status?.toLowerCase();
      const config = {
        approved: { color: "#52c41a", bg: "#f6ffed" },
        published: { color: "#52c41a", bg: "#f6ffed" },
        sold: { color: "#52c41a", bg: "#f6ffed" },
        requested: { color: "#faad14", bg: "#fffbe6" },
        unpublished: { color: "rgb(252 80 0)", bg: "rgb(255 81 0 / 9%)" },
        declined: { color: "#ff4d4f", bg: "#fff2f0" },
      };
      const style = config[statusLower] || { color: "#000", bg: "#f5f5f5" };
      return (
        <span
          style={{
            color: style.color,
            backgroundColor: style.bg,
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {status?.toUpperCase() || "N/A"}
        </span>
      );
    },
    filters: [
      { text: "Requested", value: "requested" },
      { text: "Approved", value: "approved" },
      { text: "Declined", value: "declined" },
      { text: "Unpublished", value: "unpublished" },
      { text: "Published", value: "published" },
      { text: "Sold", value: "sold" },
    ],
    onFilter: (value, record) => record.status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsReelRanking = (currentPage, pageSize, handleUpdateRanking, assetType) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Ranking",
    dataIndex: "ranking",
    key: "ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.ranking || 999999) - (b.ranking || 999999),
  },
  {
    title: "Videos",
    dataIndex: "videos",
    key: "videos",
    align: "center",
    width: 120,
    render: (videos) => {
      const video = videos?.[0]?.video;
      return video ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <video
            src={video}
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: 64,
              height: 40,
              objectFit: "cover",
              borderRadius: 4,
              border: "1px solid #e8e8e8",
              display: "block",
            }}
          />
        </div>
      ) : (
        <strong style={{ color: "#999" }}>0</strong>
      );
    },
  },
  {
    title:
      assetType === "property"
        ? "Property ID"
        : assetType === "rental_property"
          ? "Rental Property ID"
          : "Project ID",
    key: "project_property_id",
    align: "center",
    ellipsis: true,
    render: (_, record) => {
      if (assetType === "property") return record?.property?.property_id || record?.property?._id || "N/A";
      if (assetType === "rental_property") return record?.rental_property?.property_id || record?.rental_property?._id || "N/A";
      return record?.project?.project_id || "N/A";
    },
  },
  {
    title:
      assetType === "property"
        ? "Property Type"
        : assetType === "rental_property"
          ? "Rental Property Type"
          : "Project Name",
    key: "project_property_name",
    align: "center",
    ellipsis: true,
    render: (_, record) => {
      if (assetType === "property") return record?.property?.type || "N/A";
      if (assetType === "rental_property") return record?.rental_property?.type || "N/A";
      return record?.project?.project_name || "N/A";
    },
  },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
    ellipsis: true,
    render: (business_type) => business_type || "N/A",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (_, record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsProjectVideoRanking = (currentPage, pageSize, handleUpdateRanking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Video Ranking",
    dataIndex: "video_ranking",
    key: "video_ranking",
    align: "center",
    width: 100,
    render: (rank) => (
      <strong style={{ color: rank > 0 ? "#1890ff" : "#999" }}>
        {rank || "NR"}
      </strong>
    ),
    sorter: (a, b) => (a.video_ranking || 999999) - (b.video_ranking || 999999),
  },
  {
    title: "Project ID",
    dataIndex: "project_id",
    key: "project_id",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    key: "project_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Project Type",
    dataIndex: "project_type",
    key: "project_type",
    align: "center",
    ellipsis: true,
    render: (project_type) => project_type?.name || "N/A",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => {
      const statusLower = status?.toLowerCase();
      const config = {
        approved: { color: "#52c41a", bg: "#f6ffed" },
        published: { color: "#52c41a", bg: "#f6ffed" },
        sold: { color: "#52c41a", bg: "#f6ffed" },
        requested: { color: "#faad14", bg: "#fffbe6" },
        unpublished: { color: "rgb(252 80 0)", bg: "rgb(255 81 0 / 9%)" },
        declined: { color: "#ff4d4f", bg: "#fff2f0" },
      };
      const style = config[statusLower] || { color: "#000", bg: "#f5f5f5" };
      return (
        <span
          style={{
            color: style.color,
            backgroundColor: style.bg,
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          {status?.toUpperCase() || "N/A"}
        </span>
      );
    },
    filters: [
      { text: "Requested", value: "requested" },
      { text: "Approved", value: "approved" },
      { text: "Declined", value: "declined" },
      { text: "Unpublished", value: "unpublished" },
      { text: "Published", value: "published" },
      { text: "Sold", value: "sold" },
    ],
    onFilter: (value, record) => record.status === value,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    width: 120,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              key: "update",
              label: (
                <span onClick={() => handleUpdateRanking(record)}>
                  Update Video Rank
                </span>
              ),
            },
          ],
        }}
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsDoneRewardsUserPoints = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Reward Points",
    dataIndex: "reward_points",
    key: "reward_points",
    align: "center",
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    align: "center",
    render: (text) => (text ? text : "N/A"),
  },
  {
    title: "Contact Number",
    key: "user_contact_number",
    align: "center",
    render: (record) => record.contact_number || "N/A",
  },
  {
    title: "Email",
    key: "user_email",
    align: "center",
    render: (record) => record.email || "N/A",
  },
  {
    title: "Voucher Code",
    key: "voucher_code",
    align: "center",
    render: (record) => record.voucher?.voucher || "N/A",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/done_user_rewards/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* Uncomment and use handleStatusChange if needed */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsFinancePartners = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Logo",
    dataIndex: "logo",
    key: "logo",
    align: "center",
    render: (logo) =>
      logo ? (
        <img
          src={logo}
          alt="Logo"
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <span>N/A</span>
      ),
  },
  {
    title: "Company Name",
    dataIndex: "company_name",
    key: "company_name",
    align: "center",
  },
  {
    title: "Contact Number",
    key: "contact_number",
    align: "center",
    render: (_, record) =>
      `${record.country_code || ""} ${record.contact_number || ""}`,
  },
  // {
  //   title: "Address",
  //   dataIndex: "address",
  //   key: "address",
  //   align: "center",
  // },
  // {
  //   title: "Country",
  //   dataIndex: ["country", "country_name"],
  //   key: "country",
  //   align: "center",
  // },
  // {
  //   title: "State",
  //   dataIndex: ["state", "state_name"],
  //   key: "state",
  //   align: "center",
  // },
  // {
  //   title: "City",
  //   dataIndex: ["city", "city_name"],
  //   key: "city",
  //   align: "center",
  // },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "active"
              ? "green"
              : status === "inactive"
                ? "red"
                : "gray"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/finance_partners/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/finance_partners/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }

            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCancellationPolicies = (canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
  },
  {
    title: "Policy",
    dataIndex: "policy",
    key: "policy",
    align: "left",
    render: (policy) => (
      <Tooltip
        placement="top"
        title={
          Array.isArray(policy)
            ? policy.join("\n")
            : typeof policy === "string"
              ? policy
              : ""
        }
      >
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 300,
            cursor: "pointer",
          }}
        >
          {Array.isArray(policy)
            ? policy[0]
            : typeof policy === "string"
              ? policy
              : "N/A"}
          {Array.isArray(policy) && policy.length > 1 ? "..." : ""}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    align: "center",
    render: (type) => ToFirstCapital(type),
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/cancellation_policies/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/cancellation_policies/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* Add more actions as needed, e.g., Edit, Delete */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const assignBuilderColumns = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Builder ID",
    dataIndex: "builder_id",
    key: "builder_id",
    align: "center",
  },
  {
    title: "Brand Name",
    dataIndex: "brand_name",
    key: "brand_name",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Primary Email",
    dataIndex: "primary_email",
    key: "primary_email",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Contact Number",
    key: "primary_contact_number",
    align: "center",
    render: (_, record) =>
      `${record.primary_country_code || ""} ${record.primary_contact_number || ""
      }`,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Status",
    dataIndex: "account_status",
    key: "account_status",
    align: "center",
    render: (status) => (
      <Badge
        color={
          status === "approved"
            ? "green"
            : status === "inactive"
              ? "red"
              : "gray"
        }
        text={ToFirstCapital(status)}
      />
    ),
  },
  {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/builder/view/${record._id}`}>View</Link>
            </Menu.Item>

            {record.account_status !== "approved" && (
              <Menu.Item
                key="approve"
                onClick={() => handleStatusChange(record, "approved")}
              >
                Approve
              </Menu.Item>
            )}

            {record.account_status !== "inactive" && (
              <Menu.Item
                key="inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactivate
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="circle" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsProjectsAdmin = (canEdit, canAdd) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_name",
  },
  {
    title: "Project Type",
    align: "center",
    dataIndex: "project_type",
    render: (record) => (record ? record.name : ""),
  },
  {
    title: "Location",
    align: "center",
    dataIndex: "street_address",
    ellipsis: true,
  },
  {
    title: "Upload Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "approved" || status === "published" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu className="custom-action-dropdown">
            <Menu.Item key="View">
              <Link to={`/manage_projects/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="view_project">
              <Link to={`/manage_projects/view/catalogue/${record._id}`}>
                View Project Catalogue
              </Link>
            </Menu.Item>
            {canAdd &&
              <Menu.Item key="AddProperty">
                <Link to={`/manage_projects/add_property/${record._id}`}>
                  Add Property
                </Link>
              </Menu.Item>
            }
            <Menu.Item key="view_enquiry">
              <Link to={`/manage_projects/enquiries/${record._id}`}>
                View Enquiries
              </Link>
            </Menu.Item>
            {/* {record.status !== "published" ? (
              <Link to={`/manage_projects/edit/${record._id}`}>
                <Menu.Item key="edit">Edit Project</Menu.Item>
              </Link>
            ) : null} */}
            {canEdit &&
              <Menu.Item
                key="edit"
                onClick={() => {
                  record?.status === "published"
                    ? toast.error(
                      "Can't Edit a published project, Change status!!"
                    )
                    : (window.location.href = `/manage_projects/edit/${record._id}`);
                }}
              >
                Edit Project
              </Menu.Item>
            }
            <Menu.Item key="show_price_list">
              <Link to={`/manage_projects/show_price_list/${record._id}`}>
                show Price list
              </Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/project/remove", record._id);
                window.location.reload();
              }}
              key="delete"
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsEnquiry = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project_data",
    render: (record) => (record ? record.project_name : "No Data"),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user_data",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "User Contact Number",
    align: "center",
    dataIndex: "user_data",
    render: (record) => (record ? record.contact_number : "No Data"),
  },
  {
    title: "User Email",
    align: "center",
    dataIndex: "user_data",
    render: (record) => (record ? record.email : "No Data"),
  },
  {
    title: "Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", 
  //         borderRadius: "10px", 
  //       }}
  //     >
  //       <Badge
  //         color={status === "closed" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       />
  //     </span>
  //   ),
  // },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item>
  //             <Link to={`/enquiry/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //           {/* <Menu.Item
  //             style={{ color: "red" }}
  //             onClick={() => {
  //               DeleteFunction("/enquiries/remove", record._id);
  //               window.location.reload();
  //             }}
  //           >
  //             Delete
  //           </Menu.Item> */}
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />}></Button>
  //     </Dropdown>
  //   ),
  // },
];

export const columnsUserEnquiry = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.project_name : "No Data"),
  },
  {
    title: "Builder",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.brand_name : "No Data"),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "User Contact Number",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.contact_number : "No Data"),
  },
  {
    title: "User Email",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.email : "No Data"),
  },
  {
    title: "Number of Views",
    align: "center",
    dataIndex: "count",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (record) => (record ? new Date(record).toLocaleString() : ""),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item>
              <Link to={`/enquiry/user-view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />}></Button>
      </Dropdown>
    ),
  },
];

export const columnsUserEnquiryResale = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    render: (record) => (record ? record.project_name : "No Data"),
  },
  {
    title: "Property Id",
    align: "center",
    dataIndex: "property",
    render: (record) =>
      record && record.property_id ? record.property_id : "No Data",
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.name : "No Data"),
  },
  {
    title: "User Contact Number",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.contact_number : "No Data"),
  },
  {
    title: "User Email",
    align: "center",
    dataIndex: "user",
    render: (record) => (record ? record.email : "No Data"),
  },
  {
    title: "Number of Views",
    align: "center",
    dataIndex: "count",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (record) => (record ? new Date(record).toLocaleString() : ""),
  }
];

export const columnsProperties = [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Property Id",
    dataIndex: "property_id",
    key: "property_id",
    align: "center",
  },
  {
    title: "Property Type",
    dataIndex: "category",
    key: "category",
    align: "center",
    render: (record) => (record ? record?.name : "N/A"),
  },
  {
    title: "Project Type",
    dataIndex: "project_type",
    key: "property_id",
    align: "center",
    render: (record) => record?.name || "No Data",
  },
  {
    title: "Project Name",
    dataIndex: "project",
    key: "project",
    align: "center",
    render: (record) => {
      return record?.project_name || "No Data";
    },
  },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
  },
  {
    title: "Type",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    render: (record) => {
      return record?.name || "No Data";
    },
  },
  {
    title: "Added By",
    dataIndex: "added_by",
    key: "added_by",
    align: "center",
  },
  {
    title: "Location",
    dataIndex: "street_address",
    key: "project",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },

  {
    title: "Construction Status",
    key: "construction_status",
    align: "center",
    dataIndex: "construction_status",
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
          whiteSpace: "nowrap"
        }}
      >
        <Badge
          color={status === "published" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Link to={`/manage_properties/view/${record._id}`}>
              <Menu.Item key="view">View</Menu.Item>
            </Link>
            {/* {record?.added_by === "admin" &&
              record?.status?.trim().toLowerCase() !== "published" && (
                <Menu.Item key="view">
                  <Link to={`/manage_properties/edit/${record._id}`}>
                    Edit Property
                  </Link>
                </Menu.Item>
              )} */}
            {/* <Menu.Item
              key="edit"
              onClick={() => {
                record?.status === "published" || record?.added_by !== "admin"
                  ? toast.error(
                    "Cannot edit a Published and Builder's added property!!"
                  )
                  : (window.location.href = `/manage_properties/edit/${record._id}`);
              }}
            >
              Edit Property
            </Menu.Item> */}

            {/* {record?.added_by === "admin" ? (
              <Menu.Item
                style={{ color: "red" }}
                onClick={async () => {
                  await DeleteFunction("/property/remove", record._id);
                  window.location.reload();
                }}
                key="view"
              >
                Delete Property
              </Menu.Item>
            ) : null} */}
          </Menu>
        }
      >
        <Button
          shape="square"
          icon={<EllipsisOutlined></EllipsisOutlined>}
        ></Button>
      </Dropdown>
    ),
  },
];

// ─── AR Cell ─────────────────────────────────────────────────────────────────

// const ARCell = ({ record }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Dropdown
//         trigger={["click"]}
//         overlay={
//           <Menu>
//             <Menu.Item key="view">
//               <Link to={`/properties_types/view/${record._id}`}>View</Link>
//             </Menu.Item>
//             <Menu.Item key="edit">
//               <Link to={`/properties_types/edit/${record._id}`}>Edit</Link>
//             </Menu.Item>
//             <Menu.Item key="ar" onClick={() => setOpen(true)}>
//               Add AR
//             </Menu.Item>
//           </Menu>
//         }
//       >
//         <Button shape="square" icon={<EllipsisOutlined />} />
//       </Dropdown>

//       {open && (
//         <AddAR
//           arData={{ data: record }}
//           onArRemoved={() => { }}
//           onClose={() => setOpen(false)}
//         />
//       )}
//     </>
//   );
// };

// ─── VR Cell ─────────────────────────────────────────────────────────────────

// const VRCell = ({ record }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Dropdown
//         trigger={["click"]}
//         overlay={
//           <Menu>
//             <Menu.Item key="view">
//               <Link to={`/properties_types/view/${record._id}`}>View</Link>
//             </Menu.Item>
//             <Menu.Item key="edit">
//               <Link to={`/properties_types/edit/${record._id}`}>Edit</Link>
//             </Menu.Item>
//             <Menu.Item key="vr" onClick={() => setOpen(true)}>
//               Add VR
//             </Menu.Item>
//           </Menu>
//         }
//       >
//         <Button shape="square" icon={<EllipsisOutlined />} />
//       </Dropdown>

//       {open && (
//         <AddVr
//           vrData={{ data: record }}
//           onVrRemoved={() => { }}
//           onClose={() => setOpen(false)}
//         />
//       )}
//     </>
//   );
// };

// ─── Reel Cell ────────────────────────────────────────────────────────────────

// const ReelCellProperty = ({ record }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <Dropdown
//         trigger={["click"]}
//         overlay={
//           <Menu>
//             <Menu.Item key="view">
//               <Link to={`/properties_types/view/${record._id}`}>View</Link>
//             </Menu.Item>
//             <Menu.Item key="edit">
//               <Link to={`/properties_types/edit/${record._id}`}>Edit</Link>
//             </Menu.Item>
//             <Menu.Item key="reel" onClick={() => setOpen(true)}>
//               Add Reel
//             </Menu.Item>
//           </Menu>
//         }
//       >
//         <Button shape="square" icon={<EllipsisOutlined />} />
//       </Dropdown>

//       {open && (
//         <VideoModalProject
//           projectId={record._id}
//           onClose={() => setOpen(false)}
//         />
//       )}
//     </>
//   );
// };

// ─── Portal Wrapper ───────────────────────────────────────────────────────────
const ModalPortal = ({ children, onClose }) => {
  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
      }}
    >
      <div onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body
  );
};

// ─── Action Cell ─────────────────────────────────────────────────────────────
const ActionCell = ({ record }) => {
  const [openAR, setOpenAR] = useState(false);
  const [openVR, setOpenVR] = useState(false);
  const [openReel, setOpenReel] = useState(false);

  return (
    <>
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/properties_types/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item key="edit">
              <Link to={`/properties_types/edit/${record._id}`}>Edit</Link>
            </Menu.Item> */}
            <Menu.Divider />
            <Menu.Item key="vr" onClick={() => setOpenVR(true)}>
              Add VR
            </Menu.Item>
            <Menu.Item key="ar" onClick={() => setOpenAR(true)}>
              Add AR
            </Menu.Item>
            <Menu.Item key="reel" onClick={() => setOpenReel(true)}>
              Add Reel
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>

      {openVR && (
        <ModalPortal onClose={() => setOpenVR(false)}>
          <AddVr
            vrData={{ data: record }}
            onVrRemoved={() => { }}
            onClose={() => setOpenVR(false)}
          />
        </ModalPortal>
      )}

      {openAR && (
        <ModalPortal onClose={() => setOpenAR(false)}>
          <AddAR
            arData={{ data: record }}
            onArRemoved={() => { }}
            onClose={() => setOpenAR(false)}
          />
        </ModalPortal>
      )}

      {openReel && (
        <VideoModal
          propertyId={record._id}
          onClose={() => setOpenReel(false)}
        />
      )}
    </>
  );
};

const ActionCellRental = ({ record }) => {
  const [openAR, setOpenAR] = useState(false);
  const [openVR, setOpenVR] = useState(false);
  const [openReel, setOpenReel] = useState(false);

  return (
    <>
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/rental_property/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item key="edit">
              <Link to={`/properties_types/edit/${record._id}`}>Edit</Link>
            </Menu.Item> */}
            <Menu.Divider />
            <Menu.Item key="vr" onClick={() => setOpenVR(true)}>
              Add VR
            </Menu.Item>
            <Menu.Item key="ar" onClick={() => setOpenAR(true)}>
              Add AR
            </Menu.Item>
            <Menu.Item key="reel" onClick={() => setOpenReel(true)}>
              Add Reel
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>

      {openVR && (
        <ModalPortal onClose={() => setOpenVR(false)}>
          <AddRentalVr
            vrData={{ data: record }}
            onVrRemoved={() => { }}
            onClose={() => setOpenVR(false)}
          />
        </ModalPortal>
      )}

      {openAR && (
        <ModalPortal onClose={() => setOpenAR(false)}>
          <AddRentalAR
            arData={{ data: record }}
            onArRemoved={() => { }}
            onClose={() => setOpenAR(false)}
          />
        </ModalPortal>
      )}

      {openReel && (
        <RentalVideoModal
          propertyId={record._id}
          onClose={() => setOpenReel(false)}
        />
      )}
    </>
  );
};

const ActionCellProject = ({ record, onPopularToggle }) => {
  const dispatch = useDispatch();
  const [openAR, setOpenAR] = useState(false);
  const [openVR, setOpenVR] = useState(false);
  const [openReel, setOpenReel] = useState(false);
  const [freshProjectData, setFreshProjectData] = useState(null);
  const [isPopular, setIsPopular] = useState(record?.is_popular || false);
  const [popularLoading, setPopularLoading] = useState(false);

  const fetchProject = async () => {
    try {
      const response = await dispatch(getProjectData(record._id));
      if (response?.statusCode === 200 && response?.data) {
        setFreshProjectData(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleOpenVR = async () => {
    setOpenVR(true);
    await fetchProject();
  };

  const handleOpenAR = async () => {
    setOpenAR(true);
    await fetchProject();
  };

  const handleTogglePopular = async () => {
    try {
      setPopularLoading(true);
      const newValue = !isPopular;
      const res = await dispatch(updateProjectIsPopular({
        id: record._id,
        is_popular: newValue,
      }));
      if (res?.statusCode === 200) {
        setIsPopular(newValue);
        if (onPopularToggle) onPopularToggle(); // ← triggers list refresh
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPopularLoading(false);
    }
  };


  return (
    <>
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/resale_project/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/resale_project/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="vr" onClick={handleOpenVR}>
              Add VR
            </Menu.Item>
            <Menu.Item key="ar" onClick={handleOpenAR}>
              Add AR
            </Menu.Item>
            <Menu.Item key="reel" onClick={() => setOpenReel(true)}>
              Add Reel
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              key="popular"
              onClick={handleTogglePopular}
              disabled={popularLoading}
              style={{ color: isPopular ? "#b91c1c" : "#15803d" }}
            >
              {popularLoading
                ? "Updating..."
                : isPopular
                  ? "Remove from Popular"
                  : "Mark as Popular"}
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>

      {openVR && (
        <ModalPortal onClose={() => setOpenVR(false)}>
          <AddVrProject
            vrData={{ data: freshProjectData || record }}
            onVrRemoved={fetchProject}
            onClose={() => { setOpenVR(false); setFreshProjectData(null); }}
          />
        </ModalPortal>
      )}

      {openAR && (
        <ModalPortal onClose={() => setOpenAR(false)}>
          <AddARProject
            arData={{ data: freshProjectData || record }}
            onArRemoved={fetchProject}
            onClose={() => { setOpenAR(false); setFreshProjectData(null); }}
          />
        </ModalPortal>
      )}

      {openReel && (
        <VideoModalProject
          projectId={record._id}
          onClose={() => setOpenReel(false)}
        />
      )}
    </>
  );
};
// ─── Updated columnsPropertiesResale ─────────────────────────────────────────

export const columnsPropertiesResale = (businessType) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Property Id",
    dataIndex: "property_id",
    key: "property_id",
    align: "center",
  },
  {
    title: "Property Name",          // ✅ New column
    dataIndex: "property_name",
    key: "property_name",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Property Type",
    dataIndex: "category",
    key: "property_type",
    align: "center",
    render: (record) => record?.name || "N/A",
  },
  // ✅ Hidden when businessType === "business"
  ...(businessType !== "business" ? [
    {
      title: "Project Type",
      dataIndex: "project_type",
      key: "project_type",
      align: "center",
      render: (record) => record?.name || "No Data",
    },
    {
      title: "Project Name",
      dataIndex: "project",
      key: "project",
      align: "center",
      render: (record) => record?.project_name || "Not Assigned",
    },
  ] : []),
  // {
  //   title: "Type",
  //   dataIndex: "unit_type",
  //   key: "unit_type",
  //   align: "center",
  //   render: (text) => text || "No Data",
  // },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Location",
    dataIndex: "street_address",
    key: "street_address",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 200, cursor: "pointer" }}>
          {text || "No Data"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span style={{ display: "inline-flex", alignItems: "center", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "10px" }}>
        <Badge color={status === "published" ? "green" : "red"} text={ToFirstCapital(status || "N/A")} />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => <ActionCell record={record} />,
  },
];


export const columnsPropertiesRental = (currentPage, pageSize, businessType) => [
  {
    title: "Sr No.",
    align: "center",
    // width: 10,
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Property Id",
    dataIndex: "property_id",
    key: "property_id",
    align: "center",
  },
  {
    title: "Project Name",
    dataIndex: "property_name",
    key: "property_name",
    align: "center",
    render: (text, record) => {
      const name =
        record?.project_name ||
        record?.project_id?.project_name ||
        record?.property_name;

      const bedrooms = record?.no_of_bedroom;

      if (!name) return "No Data";

      return (
        <div style={{ textAlign: "center" }}>
          <div>{name}</div>
          {bedrooms ? (
            <div style={{ fontSize: 12, color: "#888" }}>{bedrooms} BHK</div>
          ) : null}
        </div>
      );
    },
  },
  ...(businessType !== "business" ? [
    {
      title: "Project Type",
      dataIndex: "project_type",
      key: "project_type",
      align: "center",
      render: (record) => record?.name || "No Data",
    },
    // {
    //   title: "Project Name",
    //   dataIndex: "project_name",
    //   key: "project_name",
    //   align: "center",
    //   render: (text, record) => {
    //     const name = record?.project_name || record?.project_id?.project_name;
    //     return name && name.trim() !== "" ? name : "No Data";
    //   },
    // },
  ] : []),
  // {
  //   title: "Type",
  //   dataIndex: "unit_type",
  //   key: "unit_type",
  //   align: "center",
  //   render: (text) => text || "No Data",
  // },
  {
    title: "Business Type",
    dataIndex: "business_type",
    key: "business_type",
    align: "center",
    render: (text) => text || "No Data",
  },
  {
    title: "Location",
    dataIndex: "street_address",
    key: "street_address",
    align: "center",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 200, cursor: "pointer" }}>
          {text || "No Data"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span style={{ display: "inline-flex", alignItems: "center", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "10px" }}>
        <Badge color={status === "published" ? "green" : "red"} text={ToFirstCapital(status || "N/A")} />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    render: (_, record) => <ActionCellRental record={record} />,
  },
];

export const columnsTeams = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    width: 80,

    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Employee ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  // {
  //   title: "Designation",
  //   align: "center",
  //   key: "designation",
  //   dataIndex: "designation",
  // },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  // },
  // {
  //   title: "Joining Data",
  //   align: "center",
  //   // key:"live_projects",
  //   dataIndex: "joining_date",
  // },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "BLOCK" ? "red" : "green"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/team/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/team/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* Show Active only if status is NOT active */}
            {record.status !== "BLOCK" && canEdit && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )}

            {/* Show Inactive only if status is NOT inactive */}
            {record.status !== "UNBLOCK" && canEdit && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsRentalBookings = (handleViewBooking) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    key: "booking_id",
    dataIndex: "booking_id",
    render: (val) => val || "—",
  },
  {
    title: "Customer",
    align: "center",
    key: "user",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.user?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.user?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "Property",
    align: "center",
    key: "rental_property",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.rental_property?.property_id || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.rental_property?.property_name || "—"}</div>
      </div>
    ),
  },
  // {
  //   title: "Location",
  //   align: "center",
  //   key: "location",
  //   render: (_, record) => {
  //     const parts = [record?.city?.city_name, record?.state?.state_name, record?.country?.country_name].filter(Boolean);
  //     return parts.length ? parts.join(", ") : "—";
  //   },
  // },
  {
    title: "Owner",
    align: "center",
    key: "owner",
    render: (_, record) => record?.owner?.name || "—",
  },
  {
    title: "Monthly Rent",
    align: "center",
    key: "monthly_rent",
    render: (_, record) => (record?.monthly_rent != null ? `${record?.currency || ""} ${record.monthly_rent}` : "—"),
  },
  {
    title: "Total",
    align: "center",
    key: "total",
    render: (_, record) => (record?.total != null ? `${record?.currency || ""} ${record.total}` : "—"),
  },
  {
    title: "Booking Status",
    align: "center",
    key: "booking_status",
    dataIndex: "booking_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
          whiteSpace: "nowrap"
        }}
      >
        <Badge
          color={
            status === "completed" ? "green" :
              status === "cancelled" ? "red" : "orange"
          }
          text={status ? ToFirstCapital(status.replace(/_/g, " ")) : "—"}
        />
      </span>
    ),
  },
  {
    title: "Payment Status",
    align: "center",
    key: "payment_status",
    dataIndex: "payment_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "success" || status === "completed" ? "green" :
              status === "failed" ? "red" : "orange"
          }
          text={status ? ToFirstCapital(status) : "—"}
        />
      </span>
    ),
  },
  {
    title: "Payment Method",
    align: "center",
    key: "payment_method",
    dataIndex: "payment_method",
    render: (val) => (val ? ToFirstCapital(val) : "—"),
  },
  {
    title: "Move-in Date",
    align: "center",
    dataIndex: "move_in_date",
    key: "move_in_date",
    render: (date) => (date ? new Date(date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—"),
  },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "booking_date",
    key: "booking_date",
    render: (date) => (date ? DateToLocale(date) : "—"),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => handleViewBooking(record)}>
              View Details
            </Menu.Item>
            {record.booking_pdf_url && (
              <Menu.Item
                key="view-pdf"
                onClick={() => window.open(record.booking_pdf_url, "_blank")}
              >
                View Booking PDF
              </Menu.Item>
            )}
            {record.payment_link && record.payment_status === "pending" && (
              <Menu.Item
                key="payment-link"
                onClick={() => window.open(record.payment_link, "_blank")}
              >
                View Payment Link
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

const personCell = (p) =>
  p ? (
    <div>
      <div style={{ fontWeight: 600 }}>{p.name || "—"}</div>
      <div style={{ fontSize: 12, color: "#888" }}>{p.email || p.contact_number || "—"}</div>
    </div>
  ) : "—";

const visitStatusCell = (status) => (
  <span style={{ display: "inline-flex", alignItems: "center", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "10px" }}>
    <Badge
      color={status === "completed" ? "green" : ["cancelled", "declined"].includes(status) ? "red" : "orange"}
      text={status ? ToFirstCapital(status) : "—"}
    />
  </span>
);

const commonVisitColumns = (offset) => [
  { title: "Sr No.", align: "center", render: (_, __, index) => offset + index + 1 },
  { title: "Lead", align: "center", key: "user", render: (_, r) => personCell(r.user) },
  { title: "Partner", align: "center", key: "agent", render: (_, r) => personCell(r.agent) },
  { title: "City Head", align: "center", key: "city_head", render: (_, r) => personCell(r.city_head) },
  { title: "Locality Head", align: "center", key: "locality_head", render: (_, r) => personCell(r.locality_head) },
];

const visitTail = (viewBase) => [
  { title: "Status", align: "center", key: "status", dataIndex: "status", render: visitStatusCell },
  { title: "Created At", align: "center", dataIndex: "created_at", key: "created_at", render: (d) => (d ? DateToLocale(d) : "—") },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Link
        to={`${viewBase}/${record._id}`}
        style={{
          display: "inline-block",
          padding: "4px 14px",
          borderRadius: 8,
          background: "#0D152B",
          color: "#fff",
          fontSize: 12.5,
          fontWeight: 500,
        }}
      >
        View
      </Link>
    ),
  },
];

export const columnsSiteVisit = (offset = 0) => [
  ...commonVisitColumns(offset),
  { title: "Project", align: "center", key: "project", render: (_, r) => r.project?.project_name || "—" },
  { title: "Visit By", align: "center", key: "site_visit_by", dataIndex: "site_visit_by", render: (v) => (v ? ToFirstCapital(v) : "—") },
  { title: "Visit Date", align: "center", key: "site_visit_date_time", dataIndex: "site_visit_date_time", render: (d) => (d ? DateToLocale(d) : "—") },
  ...visitTail("/franchise/site-visit/view"),
];

export const columnsHomeVisit = (offset = 0) => [
  ...commonVisitColumns(offset),
  // { title: "Type", align: "center", key: "business_type", dataIndex: "business_type", render: (v) => (v ? ToFirstCapital(v) : "—") },
  {
    title: "Appointment Date",
    align: "center",
    key: "appointment_date",
    dataIndex: "appointment_date",
    render: (d) =>
      d
        ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
        : "—",
  },
  { title: "Time Slot", align: "center", key: "time_slot", dataIndex: "time_slot", render: (v) => v || "—" },
  ...visitTail("/franchise/home-visit/view"),
];

export const columnsFranchiseManager = (handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Franchise ID",
    align: "center",
    key: "admin_id",
    dataIndex: "admin_id",
    render: (val) => val || "—",
  },
  {
    title: "Name",
    align: "center",
    key: "name",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.email || "—"}</div>
      </div>
    ),
  },
  {
    title: "Contact",
    align: "center",
    key: "contact_number",
    render: (_, record) =>
      record?.contact_number
        ? `${record?.country_code || ""} ${record.contact_number}`
        : "—",
  },
  {
    title: "City",
    align: "center",
    key: "city",
    render: (_, record) => record?.city?.[0]?.city_name || "—",
  },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  //   render: (val) => val || "—",
  // },
  {
    title: "Role",
    align: "center",
    key: "role",
    dataIndex: "role",
    render: (val) => val || "—",
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={status ? ToFirstCapital(status) : "—"}
        />
      </span>
    ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (date ? DateToLocale(date) : "—"),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/franchise/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="city-heads">
              <Link to={`/franchise/${record._id}/city-heads`} state={{ from: "/franchise" }}>
                City Heads
              </Link>
            </Menu.Item>
            <Menu.Item key="view-partners" disabled={!record.partner_count}>
              {record.partner_count ? (
                <Link
                  to={`/franchise/${record._id}/partners`}
                  state={{ from: "/franchise" }}
                >
                  View Partners
                </Link>
              ) : (
                <span>No Partners</span>
              )}
            </Menu.Item>
            <Menu.Item key="projects">
              <Link to={`/franchise/${record._id}/projects`} state={{ from: "/franchise" }}>
                Projects Commission
              </Link>
            </Menu.Item>
            <Menu.Item key="site-visits">
              <Link to={`/franchise/${record._id}/site-visits`}>Site Visits</Link>
            </Menu.Item>
            <Menu.Item key="home-visits">
              <Link to={`/franchise/${record._id}/home-visits`}>Home Visits</Link>
            </Menu.Item>
            <Menu.Item key="access-control">
              <Link to={`/franchise/access-control/${record._id}`}>Manage Access</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/franchise/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {canEdit && record.status !== "active" &&
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
                style={{ color: "#16a34a" }}
              >
                Active
              </Menu.Item>
            }
            {canEdit && record.status !== "inactive" &&
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
                style={{ color: "#dc2626" }}
              >
                Inactive
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsRentalPaymentHistory = (handleViewPayment) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    key: "booking",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.booking?.booking_id || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>
          {record?.booking?.booking_status ? ToFirstCapital(record.booking.booking_status) : "—"}
        </div>
      </div>
    ),
  },
  // {
  //   title: "Customer",
  //   align: "center",
  //   key: "user",
  //   render: (_, record) => (
  //     <div>
  //       <div style={{ fontWeight: 600 }}>{record?.user?.name || "—"}</div>
  //       <div style={{ fontSize: 12, color: "#888" }}>{record?.user?.email || "—"}</div>
  //     </div>
  //   ),
  // },
  // {
  //   title: "Property",
  //   align: "center",
  //   key: "rental_property",
  //   render: (_, record) => (
  //     <div>
  //       <div style={{ fontWeight: 600 }}>{record?.rental_property?.property_name || "—"}</div>
  //       <div style={{ fontSize: 12, color: "#888" }}>{record?.rental_property?.property_id || "—"}</div>
  //     </div>
  //   ),
  // },
  // {
  //   title: "Owner",
  //   align: "center",
  //   key: "owner",
  //   render: (_, record) => record?.owner?.email || "—",
  // },
  {
    title: "Payment For",
    align: "center",
    key: "payment_for",
    dataIndex: "payment_for",
    render: (val) => (val ? ToFirstCapital(val) : "—"),
  },
  {
    title: "Amount",
    align: "center",
    key: "amount",
    render: (_, record) => (record?.amount != null ? `${record?.currency || ""} ${record.amount}` : "—"),
  },
  {
    title: "Payment Method",
    align: "center",
    key: "payment_method",
    render: (_, record) => {
      const method = record?.payment_plan?.payment?.entity?.method;
      return method
        ? ToFirstCapital(method)
        : record?.payment_method
          ? ToFirstCapital(record.payment_method)
          : "—";
    },
  },
  {
    title: "Payment Status",
    align: "center",
    key: "payment_status",
    dataIndex: "payment_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "completed" || status === "success" || status === "approved" ? "green" :
              status === "failed" || status === "declined" ? "red" : "orange"
          }
          text={status ? ToFirstCapital(status) : "—"}
        />
      </span>
    ),
  },
  {
    title: "Refund Status",
    align: "center",
    key: "refund_status",
    dataIndex: "refund_status",
    render: (status) => (
      status && status !== "none" ? (
        <Badge
          color={status === "completed" ? "green" : status === "failed" ? "red" : "orange"}
          text={ToFirstCapital(status)}
        />
      ) : "—"
    ),
  },
  {
    title: "Order ID",
    align: "center",
    key: "order_id",
    render: (_, record) => record?.payment_plan?.order?.entity?.id || "—",
  },
  {
    title: "Payment ID",
    align: "center",
    key: "payment_id",
    render: (_, record) => record?.payment_plan?.payment?.entity?.id || "—",
  },
  {
    title: "Bank",
    align: "center",
    key: "bank",
    render: (_, record) => record?.payment_plan?.payment?.entity?.bank || "—",
  },
  // {
  //   title: "Paid At",
  //   align: "center",
  //   key: "paid_at",
  //   render: (_, record) => (record?.paid_at ? DateToLocale(record.paid_at) : "—"),
  // },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (date ? DateToLocale(date) : "—"),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view" onClick={() => handleViewPayment(record)}>
              View Details
            </Menu.Item>
            {record?.payment_plan?.payment_link?.entity?.short_url && (
              <Menu.Item
                key="payment-link"
                onClick={() => window.open(record.payment_plan.payment_link.entity.short_url, "_blank")}
              >
                View Payment Link
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsStaffUpdateRequests = (handleApproveReject) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Agent Name",
    align: "center",
    key: "staff_name",
    render: (_, record) => (
      <div>
        <div style={{ fontWeight: 600 }}>{record?.staff?.name || "—"}</div>
        <div style={{ fontSize: 12, color: "#888" }}>{record?.staff?.staff_id || "—"}</div>
      </div>
    ),
  },
  {
    title: "Agent Email",
    align: "center",
    key: "staff_email",
    render: (_, record) => record?.staff?.email || "—",
  },
  {
    title: "Agent Contact",
    align: "center",
    key: "staff_contact",
    render: (_, record) => record?.staff?.contact_number || "—",
  },
  {
    title: "Request Type",
    align: "center",
    key: "request_type",
    dataIndex: "request_type",
    render: (type) => {
      const config = {
        profile_image: { background: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
        bank_details: { background: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
        business_info: { background: "#fdf4ff", color: "#7e22ce", border: "#e9d5ff" },
      };
      const c = config[type] || { background: "#f5f5f5", color: "#595959", border: "#d9d9d9" };
      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 500,
            background: c.background,
            color: c.color,
            border: `1px solid ${c.border}`,
          }}
        >
          {type ? ToFirstCapital(type.replace(/_/g, " ")) : "—"}
        </span>
      );
    },
  },
  {
    title: "Status",
    align: "center",
    key: "status",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "approved" ? "green" :
              status === "rejected" ? "red" : "orange"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Rejected Reason",
    align: "center",
    key: "rejected_reason",
    dataIndex: "rejected_reason",
    render: (val) => val || "—",
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {record.request_type === "profile_image" && record.profile_image && (
              <Menu.Item
                key="view-image"
                icon={<EyeOutlined />}
                onClick={() => window.open(record.profile_image, "_blank")}
              >
                View Image
              </Menu.Item>
            )}
            {record.status === "pending" && (
              <>
                <Menu.Item
                  key="approve"
                  style={{ color: "green" }}
                  onClick={() => handleApproveReject(record, "approved")}
                >
                  Approve
                </Menu.Item>
                <Menu.Item
                  key="reject"
                  style={{ color: "red" }}
                  onClick={() => handleApproveReject(record, "rejected")}
                >
                  Reject
                </Menu.Item>
              </>
            )}
            {record.status !== "pending" && record.request_type !== "profile_image" && (
              <Menu.Item key="no-action" disabled>
                No Actions Available
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAgents = (handleStatusChange, onAssignFranchise) => [
  {
    title: "Sr No.",
    align: "center",
    // width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Agent Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Agent Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Agent Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Agent ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  // {
  //   title: "Designation",
  //   align: "center",
  //   key: "designation",
  //   dataIndex: "designation",
  // },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  // },
  {
    title: "Joining Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Category",
    align: "center",
    key: "category",
    dataIndex: "category",
    render: (category) => {
      const categoryConfig = {
        BASIC: { background: "#f5f5f5", color: "#595959", border: "#d9d9d9" },
        STANDARD: { background: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
        PREMIUM: { background: "#fdf4ff", color: "#7e22ce", border: "#e9d5ff" },
        LUXURY: { background: "#fffbeb", color: "#b45309", border: "#fde68a" },
      };

      const config = categoryConfig[category?.toUpperCase()] || {
        background: "#fff1f0",
        color: "#cf1322",
        border: "#ffa39e",
      };

      return (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 500,
            background: config.background,
            color: config.color,
            border: `1px solid ${config.border}`,
          }}
        >
          {category ? ToFirstCapital(category) : "N/A"}
        </span>
      );
    },
  },
  {
    title: "Profile Status",
    align: "center",
    key: "profile_status",
    dataIndex: "profile_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status && status !== "BLOCK" ? "green" : "red"}
          text={status ? ToFirstCapital(status) : "N/A"}
        />
      </span>
    ),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   key: "status",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", // Light gray border
  //         borderRadius: "10px", // Rounded edges
  //       }}
  //     >
  //       <Badge
  //         color={status === "BLOCK" ? "red" : "green"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {/* Show Active only if status is NOT active */}
            {/* {record.status !== "BLOCK" && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )} */}

            {/* Show Inactive only if status is NOT inactive */}
            {/* {record.status !== "UNBLOCK" && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )} */}

            <Menu.Item key="view">
              <Link to={`/agent/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="assign-franchise" onClick={() => onAssignFranchise(record)}>
              Assign Franchise
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsPartnerRoles = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    // width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Agent Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Agent Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Agent Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Agent ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  // {
  //   title: "Designation",
  //   align: "center",
  //   key: "designation",
  //   dataIndex: "designation",
  // },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  // },
  {
    title: "Joining Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  // {
  //   title: "Category",
  //   align: "center",
  //   key: "category",
  //   dataIndex: "category",
  //   render: (category) => {
  //     const categoryConfig = {
  //       BASIC: { background: "#f5f5f5", color: "#595959", border: "#d9d9d9" },
  //       STANDARD: { background: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
  //       PREMIUM: { background: "#fdf4ff", color: "#7e22ce", border: "#e9d5ff" },
  //       LUXURY: { background: "#fffbeb", color: "#b45309", border: "#fde68a" },
  //     };

  //     const config = categoryConfig[category?.toUpperCase()] || {
  //       background: "#fff1f0",
  //       color: "#cf1322",
  //       border: "#ffa39e",
  //     };

  //     return (
  //       <span
  //         style={{
  //           display: "inline-flex",
  //           alignItems: "center",
  //           padding: "4px 12px",
  //           borderRadius: "20px",
  //           fontSize: "12px",
  //           fontWeight: 500,
  //           background: config.background,
  //           color: config.color,
  //           border: `1px solid ${config.border}`,
  //         }}
  //       >
  //         {category ? ToFirstCapital(category) : "N/A"}
  //       </span>
  //     );
  //   },
  // },
  {
    title: "Profile Status",
    align: "center",
    key: "account_status",
    dataIndex: "account_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status && status !== "requested" ? "green" : "blue"}
          text={status ? ToFirstCapital(status) : "N/A"}
        />
      </span>
    ),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   key: "status",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", // Light gray border
  //         borderRadius: "10px", // Rounded edges
  //       }}
  //     >
  //       <Badge
  //         color={status === "BLOCK" ? "red" : "green"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {/* Show Active only if status is NOT active */}
            {/* {record.status !== "BLOCK" && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )} */}

            {/* Show Inactive only if status is NOT inactive */}
            {/* {record.status !== "UNBLOCK" && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )} */}

            <Menu.Item key="view">
              <Link to={`/partner_roles/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsReseller = (handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    // width: 80,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Agent Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Agent Email Address",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Agent Phone Number",
    align: "center",
    key: "contact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Agent ID",
    align: "center",
    key: "staff_id",
    dataIndex: "staff_id",
  },
  // {
  //   title: "Designation",
  //   align: "center",
  //   key: "designation",
  //   dataIndex: "designation",
  // },
  // {
  //   title: "Department",
  //   align: "center",
  //   key: "department",
  //   dataIndex: "department",
  // },
  {
    title: "Joining Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  // {
  //   title: "Profile Status",
  //   align: "center",
  //   key: "profile_status",
  //   dataIndex: "profile_status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={status && status !== "BLOCK" ? "green" : "red"}
  //         text={status ? ToFirstCapital(status) : "N/A"}
  //       />
  //     </span>
  //   ),
  // },
  // {
  //   title: "Status",
  //   align: "center",
  //   key: "status",
  //   dataIndex: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9", // Light gray border
  //         borderRadius: "10px", // Rounded edges
  //       }}
  //     >
  //       <Badge
  //         color={status === "BLOCK" ? "red" : "green"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {/* <Menu.Item key="view">
              <Link to={`/create_coupons/view/${record._id}`}>View</Link>
            </Menu.Item> */}
            {/* Show Active only if status is NOT active */}
            {/* {record.status !== "BLOCK" && (
              <Menu.Item
                key="BLOCK"
                onClick={() => handleStatusChange(record, "BLOCK")}
              >
                Block
              </Menu.Item>
            )} */}

            {/* Show Inactive only if status is NOT inactive */}
            {/* {record.status !== "UNBLOCK" && (
              <Menu.Item
                key="UNBLOCK"
                onClick={() => handleStatusChange(record, "UNBLOCK")}
              >
                Un-Block
              </Menu.Item>
            )} */}

            <Menu.Item key="view">
              <Link to={`/agent/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];




// helper: format date to "DD-MMM-YYYY HH:mm"
const formatDateTime = (iso) => {
  if (!iso) return "–";
  try {
    return format(new Date(iso), "dd-MMM-yyyy HH:mm");
  } catch {
    return "–";
  }
};

// helper: number to INR format (e.g., 3000000 → 3,00,000.00)
const formatINR = (value) => {
  if (typeof value !== "number") return value || "–";
  return value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const columnsVrTransaction = (handleAction = null) => {
  const getPropertyData = (record) => record?.property || record?.rental_property || null;

  return [
    {
      title: "Sr No.",
      align: "center",
      // width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Property Name",
      align: "center",
      key: "property_name",
      render: (_, record) => getPropertyData(record)?.property_name || "N/A",
    },
    {
      title: "Property ID",
      align: "center",
      key: "property_id",
      render: (_, record) => getPropertyData(record)?.property_id || "–",
    },
    {
      title: "Property Type",
      align: "center",
      key: "business_type",
      render: (_, record) => getPropertyData(record)?.business_type || "–",
    },
    {
      title: "Reseller Name",
      align: "center",
      dataIndex: ["staff", "name"],
      key: "staff_name",
      render: (name) => name || "–",
    },
    {
      title: "Reseller Email",
      align: "center",
      dataIndex: ["staff", "email"],
      key: "staff_email",
      render: (email) => email || "–",
    },

    {
      title: "Booking Amount",
      align: "center",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `₹${formatINR(amount)}`,
    },

    {
      title: "Payment Status",
      align: "center",
      dataIndex: "payment_status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge
            color={
              status === "pending"
                ? "blue"
                : status === "completed"
                  ? "green"
                  : status === "failed" || status === "refunded"
                    ? "red"
                    : "orange"
            }
            text={ToFirstCapital(status)}
          />
        </span>
      ),
    },

    {
      title: "Payment Method",
      align: "center",
      key: "method",
      render: (_, record) =>
        record?.payment_plan?.payment?.entity?.method?.toUpperCase() || "–",
    },

    {
      title: "Payment Date",
      align: "center",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => formatDateTime(date),
    },

    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="view">
                <Link to={`/vr-transaction/view/${record._id}`}>View</Link>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];
};

export const columnsTimeslot = (currentPage, pageSize, handleAction) => [
  {
    title: "Sr No.",
    align: "center",
    width: 10,
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "ID",
    align: "center",
    dataIndex: "id",
    key: "id",
    width: 10,
  },
  {
    title: "Time",
    align: "center",
    dataIndex: "time",
    key: "time",
    width: 10,
  },
  {
    title: "Available",
    align: "center",
    dataIndex: "available",
    key: "available",
    width: 10,
    render: (available) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge color={available ? "green" : "red"} text={available ? "Yes" : "No"} />
      </span>
    ),
  },
  {
    title: "Whole Day Off",
    align: "center",
    dataIndex: "disable_whole_day",
    key: "disable_whole_day",
    width: 10,
    render: (disableWholeDay) => {
      if (!Array.isArray(disableWholeDay) || disableWholeDay.length === 0) {
        return <span style={{ color: "#bfbfbf", fontSize: 12 }}>—</span>;
      }

      const today = dayjs().startOf("day"); // Add this

      // Add this filter (same as Disabled Dates column)
      const filtered = disableWholeDay.filter((rule) =>
        dayjs(rule.date).isSame(today, "day") || dayjs(rule.date).isAfter(today, "day")
      );

      if (filtered.length === 0) {
        return <span style={{ color: "#bfbfbf", fontSize: 12 }}>—</span>;
      }

      const sorted = [...filtered].sort( // Change: was [...disableWholeDay]
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      const visible = sorted.slice(0, 2);
      const hidden = sorted.slice(2);

      const tooltipContent = (
        <div style={{ maxWidth: 260 }}>
          {sorted.map((rule, i) => (
            <div key={i} style={{ marginBottom: 6 }}>
              <strong>{dayjs(rule.date).format("DD MMM YYYY")}</strong>
              {rule.reason && (
                <span style={{ color: "#d9d9d9", marginLeft: 6, fontSize: 11 }}>
                  — {rule.reason}
                </span>
              )}
            </div>
          ))}
        </div>
      );

      return (
        <Tooltip title={tooltipContent} color="#1a1a2e" placement="top">
          <span style={{ display: "inline-flex", flexWrap: "wrap", gap: 4, justifyContent: "center", cursor: "pointer" }}>
            {visible.map((rule, i) => (
              <Tag
                key={i}
                color="orange"
                style={{ borderRadius: 6, fontSize: 11, margin: 0 }}
              >
                {dayjs(rule.date).format("DD MMM")}
              </Tag>
            ))}
            {hidden.length > 0 && (
              <Tag
                color="default"
                style={{ borderRadius: 6, fontSize: 11, margin: 0, cursor: "pointer" }}
              >
                +{hidden.length} more
              </Tag>
            )}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "Disabled Dates",
    align: "center",
    dataIndex: "disable_rules",
    key: "disable_rules",
    width: 10,
    render: (disableRules) => {
      if (!Array.isArray(disableRules) || disableRules.length === 0) {
        return <span style={{ color: "#bfbfbf", fontSize: 12 }}>—</span>;
      }

      const today = dayjs().startOf("day");

      const filtered = disableRules.filter((rule) =>
        dayjs(rule.date).isSame(today, "day") || dayjs(rule.date).isAfter(today, "day")
      );

      if (filtered.length === 0) {
        return <span style={{ color: "#bfbfbf", fontSize: 12 }}>—</span>;
      }

      const sorted = [...filtered].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      const visible = sorted.slice(0, 2);
      const hidden = sorted.slice(2);

      const tooltipContent = (
        <div style={{ maxWidth: 260 }}>
          {sorted.map((rule, i) => (
            <div key={i} style={{ marginBottom: 6 }}>
              <strong>{dayjs(rule.date).format("DD MMM YYYY")}</strong>
              {rule.reason && (
                <span style={{ color: "#d9d9d9", marginLeft: 6, fontSize: 11 }}>
                  — {rule.reason}
                </span>
              )}
            </div>
          ))}
        </div>
      );

      return (
        <Tooltip title={tooltipContent} color="#1a1a2e" placement="top">
          <span style={{ display: "inline-flex", flexWrap: "wrap", gap: 4, justifyContent: "center", cursor: "pointer" }}>
            {visible.map((rule, i) => (
              <Tag
                key={i}
                icon={<StopOutlined />}
                color="error"
                style={{ borderRadius: 6, fontSize: 11, margin: 0 }}
              >
                {dayjs(rule.date).format("DD MMM")}
              </Tag>
            ))}
            {hidden.length > 0 && (
              <Tag
                color="default"
                style={{ borderRadius: 6, fontSize: 11, margin: 0, cursor: "pointer" }}
              >
                +{hidden.length} more
              </Tag>
            )}
          </span>
        </Tooltip>
      );
    },
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    width: 10,
    render: (_, record) => (
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item
              key="disable"
              onClick={() => handleAction(record, "disable")}
              style={{ color: "#ff4d4f" }}
            >
              Edit
            </Menu.Item>
          </Menu>
        }
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUnits = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    Flex: "nowrap",
    dataIndex: "",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Unit Type",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Category",
    align: "center",
    dataIndex: "category_name",
    key: "category_name",
  },
  {
    title: "Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/furnishing/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/furnishing/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/unit/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBookings = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: "booking_id",
    key: "booking_id",
  },
  {
    title: "User name",
    align: "center",
    dataIndex: "user",
    key: "user_name",
    render: (record) => record?.name || "No Data",
  },
  // {
  //   title: "Email Address",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "email",
  //   render: (record) => record?.email || "No Data",
  // },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "user",
    key: "contact_number",
    render: (record) => record?.contact_number || "No Data",
  },
  {
    title: "User Documents",
    align: "center",
    dataIndex: "user",
    key: "documents",
    ellipsis: false, // <== Important: prevents truncation
    render: (record) => {
      if (
        !record?.documents ||
        !Array.isArray(record.documents) ||
        record.documents.length === 0
      )
        return (
          <p style={{ color: "red" }}>No documents</p>
        );

      return (
        <div style={{ width: "100%", cursor: "pointer" }}>
          <Dropdown
            overlay={
              <Menu>
                {record.documents.map((doc, index) => (
                  <Menu.Item key={index}>
                    <a href={doc.url} target="_blank" rel="noopener noreferrer">
                      {doc.name}
                    </a>
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <span style={{ color: "blue" }}>View Documents</span>
          </Dropdown>
        </div>
      );
    },
    // render: (record) => {
    //   if (Array.isArray(record.documents) && record.documents.length === 0)
    //     return (
    //       <p style={{ color: "red" }}>No documents uploaded by the user</p>
    //     );
    //   return (
    //     <div style={{ width: "100%", cursor: "pointer" }}>
    //       <Dropdown
    //         overlay={
    //           <Menu>
    //             {Array.isArray(record.documents) &&
    //             record.documents.length > 0 ? (
    //               record.documents.map((doc, index) => (
    //                 <Menu.Item key={index}>
    //                   <a
    //                     href={doc.url}
    //                     target="_blank"
    //                     rel="noopener noreferrer"
    //                   >
    //                     {doc.name}
    //                   </a>
    //                 </Menu.Item>
    //               ))
    //             ) : (
    //               <Menu.Item disabled>
    //                 No documents uploaded by the user
    //               </Menu.Item>
    //             )}
    //           </Menu>
    //         }
    //         trigger={["click"]}
    //       >
    //         <span style={{ color: "blue" }}>View Documents</span>
    //       </Dropdown>
    //     </div>
    //   );
    // },
  },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "created_at",
    key: "booking_date",
    render: (record) => {
      const dateObj = new Date(record);
      return dateObj.toLocaleDateString();
    },
  },
  // {
  //   title: "Time",
  //   align: "center",
  //   dataIndex: "created_at",
  //   key: "Time",
  //   render: (createdAt) => {
  //     if (!createdAt) return "";
  //     const date = new Date(createdAt);
  //     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  //   },
  // },
  {
    title: "Project",
    align: "center",
    dataIndex: "project",
    key: "project",
    render: (record) => record?.project_name || "No Data",
  },
  {
    title: "Booking Status",
    align: "center",
    dataIndex: "booking_status",
    key: "project",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    key: "project",
  },
  // {
  //   title: "Payment Type",
  //   align: "center",
  //   dataIndex: "booked_property",
  //   key: "payment_type",
  //   render: (record) => record?.plan_type || "No Data",
  // },
  {
    title: "Booked Unit",
    align: "center",
    dataIndex: "properties",
    key: "booked_unit",
    render: (record) => record?.length || "0",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/bookings/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUserBookings = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: "booking_id",
    key: "booking_id",
  },
  // {
  //   title: "User name",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "user_name",
  //   render: (record) => record?.name || "No Data",
  // },
  // {
  //   title: "Email Address",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "email",
  //   render: (record) => record?.email || "No Data",
  // },
  // {
  //   title: "Phone Number",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "contact_number",
  //   render: (record) => record?.contact_number || "No Data",
  // },
  // {
  //   title: "User Documents",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "documents",
  //   ellipsis: false, // <== Important: prevents truncation
  //   render: (record) => {
  //     if (
  //       !record?.documents ||
  //       !Array.isArray(record.documents) ||
  //       record.documents.length === 0
  //     )
  //       return (
  //         <p style={{ color: "red" }}>No documents</p>
  //       );

  //     return (
  //       <div style={{ width: "100%", cursor: "pointer" }}>
  //         <Dropdown
  //           overlay={
  //             <Menu>
  //               {record.documents.map((doc, index) => (
  //                 <Menu.Item key={index}>
  //                   <a href={doc.url} target="_blank" rel="noopener noreferrer">
  //                     {doc.name}
  //                   </a>
  //                 </Menu.Item>
  //               ))}
  //             </Menu>
  //           }
  //           trigger={["click"]}
  //         >
  //           <span style={{ color: "blue" }}>View Documents</span>
  //         </Dropdown>
  //       </div>
  //     );
  //   },
  //   // render: (record) => {
  //   //   if (Array.isArray(record.documents) && record.documents.length === 0)
  //   //     return (
  //   //       <p style={{ color: "red" }}>No documents uploaded by the user</p>
  //   //     );
  //   //   return (
  //   //     <div style={{ width: "100%", cursor: "pointer" }}>
  //   //       <Dropdown
  //   //         overlay={
  //   //           <Menu>
  //   //             {Array.isArray(record.documents) &&
  //   //             record.documents.length > 0 ? (
  //   //               record.documents.map((doc, index) => (
  //   //                 <Menu.Item key={index}>
  //   //                   <a
  //   //                     href={doc.url}
  //   //                     target="_blank"
  //   //                     rel="noopener noreferrer"
  //   //                   >
  //   //                     {doc.name}
  //   //                   </a>
  //   //                 </Menu.Item>
  //   //               ))
  //   //             ) : (
  //   //               <Menu.Item disabled>
  //   //                 No documents uploaded by the user
  //   //               </Menu.Item>
  //   //             )}
  //   //           </Menu>
  //   //         }
  //   //         trigger={["click"]}
  //   //       >
  //   //         <span style={{ color: "blue" }}>View Documents</span>
  //   //       </Dropdown>
  //   //     </div>
  //   //   );
  //   // },
  // },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "created_at",
    key: "booking_date",
    render: (record) => {
      const dateObj = new Date(record);
      return dateObj.toLocaleDateString();
    },
  },
  // {
  //   title: "Time",
  //   align: "center",
  //   dataIndex: "created_at",
  //   key: "Time",
  //   render: (createdAt) => {
  //     if (!createdAt) return "";
  //     const date = new Date(createdAt);
  //     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  //   },
  // },
  {
    title: "Project",
    align: "center",
    dataIndex: "project_data",
    key: "project_data",
    render: (record) => record?.project_name || "No Data",
  },
  {
    title: "Booking Status",
    align: "center",
    dataIndex: "booking_status",
    key: "project",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    key: "project",
  },
  // {
  //   title: "Payment Type",
  //   align: "center",
  //   dataIndex: "booked_property",
  //   key: "payment_type",
  //   render: (record) => record?.plan_type || "No Data",
  // },
  {
    title: "Booked Unit",
    align: "center",
    dataIndex: "properties",
    key: "booked_unit",
    render: (record) => record?.length || "0",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/bookings/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBookingsPayment = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Booking ID",
    align: "center",
    dataIndex: "booking_id",
    key: "booking_id",
  },
  {
    title: "User name",
    align: "center",
    dataIndex: "user",
    key: "user_name",
    render: (user) => user?.name || "No Data",
  },
  {
    title: "Email Address",
    align: "center",
    dataIndex: "user",
    key: "email",
    render: (user) => user?.email || "No Data",
  },
  {
    title: "Phone Number",
    align: "center",
    dataIndex: "user",
    key: "contact_number",
    render: (user) => user?.contact_number || "No Data",
  },
  {
    title: "Booking Date",
    align: "center",
    dataIndex: "created_at",
    key: "booking_date",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "No Data"),
  },
  {
    title: "Time",
    align: "center",
    dataIndex: "created_at",
    key: "time",
    render: (date) => (date ? new Date(date).toLocaleTimeString() : "No Data"),
  },
  {
    title: "Project",
    align: "center",
    dataIndex: "project",
    key: "project",
    render: (project) => project?.project_name || "No Data",
  },
  {
    title: "Booked Unit",
    align: "center",
    dataIndex: "properties",
    key: "booked_unit",
    render: (properties) =>
      Array.isArray(properties) ? properties.length : "No Data",
  },
  {
    title: "Booking Amount",
    align: "center",
    dataIndex: "booking_amount",
    key: "booking_amount",
    render: (amount) =>
      amount !== undefined && amount !== null
        ? `₹${amount.toLocaleString()}`
        : "No Data",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    key: "payment_status",
    render: (status) => status || "No Data",
  },
  {
    title: "Refund Status",
    align: "center",
    dataIndex: "refund_status",
    key: "refund_status",
    render: (status) => status || "No Data",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/bookings/payment-executive/view/${record._id}`}>
                View
              </Link>
            </Menu.Item>
            <Menu.Item key="chat">
              <Link to={`/chat_and_support/pay_exec/${record._id}`}>Chat</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsPages = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Created Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Type",
    align: "center",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/pages/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/pages/delete/${record._id}`}>delete</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsAds = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Description",
    align: "center",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Banner",
    align: "center",
    dataIndex: "cover_photo",
    key: "cover_photo",
    render: (_, record, index) => (
      <img
        key={index}
        style={{ height: "20px", width: "50px" }}
        alt=""
        src={
          record?.cover_photo || require("../Global Icons/AlternateImage.png")
        }
      ></img>
    ),
  },
  {
    title: "Type",
    align: "center",
    dataIndex: "type",
    key: "type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item onClick={() => { }} key="view">
              <Link to={``}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={``}>Edit</Link>
            </Menu.Item>
            <Menu.Item key="delete">
              <Link to={``}>Delete</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsDeals = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    key: "project_name",
    render: (_, record, index) =>
      Array.isArray(record?.project) ? record?.project[0]?.project_name : "N/A",
  },
  {
    title: "Deal Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "created_at",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Discount Type",
    align: "center",
    dataIndex: "discount_type",
    key: "discount_type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Value",
    align: "center",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/deals/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];
export const columnsDealsList = (handleStatusChange, canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Project Name",
    align: "center",
    dataIndex: "project",
    key: "project_name",
    render: (project) => project?.[0]?.project_name || "N/A",
  },
  {
    title: "Deal Name",
    align: "center",
    dataIndex: "name",
    key: "name",
    render: (name, record) => name ?? "N/A",
  },
  {
    title: "Image",
    dataIndex: "image",
    align: "center",
    key: "image",
    render: (text) => (
      <img
        src={text}
        alt="item"
        style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
      />
    ),
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "created_at",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Discount Type",
    align: "center",
    dataIndex: "discount_type",
    key: "discount_type",
    render: (record) => ToFirstCapital(record),
  },
  {
    title: "Value",
    align: "center",
    dataIndex: "value",
    key: "value",
    render: (value, record) => value ?? "N/A",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/deals/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/deals/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCurrencyList = (handleStatusChange) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Country Name",
    align: "center",
    dataIndex: "name",
    key: "country_name",
  },
  {
    title: "Currency",
    align: "center",
    dataIndex: "currency",
    key: "currency",
  },
  {
    title: "Tax (%)",
    align: "center",
    dataIndex: "tax",
    key: "tax",
  },
  {
    title: "Booking Amount %",
    align: "center",
    dataIndex: "booking_amount_percent",
    key: "booking_amount_percent",
  },
  {
    title: "Max Booking Amount",
    align: "center",
    dataIndex: "max_booking_amount",
    key: "max_booking_amount",
  },
  {
    title: "Min Booking Amount",
    align: "center",
    dataIndex: "min_booking_amount",
    key: "min_booking_amount",
  },
  {
    title: "Min Booking Amount Kiosk",
    align: "center",
    dataIndex: "min_booking_amount_kiosk",
    key: "min_booking_amount_kiosk",
  },
  {
    title: "Max Booking Amount Kiosk",
    align: "center",
    dataIndex: "max_booking_amount_kiosk",
    key: "max_booking_amount_kiosk",
  },
  {
    title: "Max Property Price",
    align: "center",
    dataIndex: "max_property_price",
    key: "max_property_price",
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   key: "action",
  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           {/* Customize actions as needed */}
  //           <Menu.Item key="edit">
  //             {/* Example Edit Link, update path as appropriate */}
  //             <Link to={`/currency/edit/${record._id}`}>Edit</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];


export const columnsConsultant = (getCellClick) => [
  { title: "Sr No.", render: (_, __, index) => index + 1 },
  {
    title: "Name",
    align: "center",
    dataIndex: "first_name",
    key: "first_name",
  },
  {
    title: "Email",
    align: "center",
    key: "email",
    dataIndex: "email",
  },
  {
    title: "Country Code",
    align: "center",
    key: "country_code",
    dataIndex: "country_code",
  },
  {
    title: "Phone",
    align: "center",
    key: "conact_number",
    dataIndex: "contact_number",
  },
  {
    title: "Id",
    align: "center",
    key: "consultant_id",
    dataIndex: "consultant_id",
  },
  {
    title: "Created",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => DateToLocale(date),
  },
  {
    title: "Actions",
    align: "center",
    dataIndex: "action",
    key: "action",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/Consultants/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsPayments = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Payment ID",
    align: "center",
    dataIndex: "payment_id",
    key: "payment_id",
  },
  {
    title: "Payment Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
    render: (amount, record) => {
      const currencySymbol = record.currency === "INR" ? "₹" : record.currency;
      return `${currencySymbol} ${amount}`;
    },
  },
  // {
  //   title: "Booking Amount",
  //   align: "center",
  //   dataIndex: "booking_amount",
  //   key: "booking_amount",
  //   render: (record) => record?.toFixed(2),
  // },
  // {
  //   title: "Project Name",
  //   align: "center",
  //   dataIndex: "project",
  //   key: "project",
  //   render: (record) => record.project_name || "No Data",
  // },
  {
    title: "Payment Type",
    align: "center",
    dataIndex: "payment_type",
    key: "payment_type",
  },
  // {
  //   title: "User Name",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "user",
  //   render: (record) => record?.name || "No Data",
  // },
  // {
  //   title: "User Contact Number",
  //   align: "center",
  //   dataIndex: "user",
  //   key: "user",
  //   render: (record) => record?.contact_number || "No Data",
  // },

  {
    title: "Status",
    align: "center",
    dataIndex: "payment_status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "pending" ? "red" : "green"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/payments/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsRequestPayments = (currentPage, pageSize, handleStatusChange, openRejectPopup, openApprovePopup, openViewReasonPopup, role) => {
  const baseColumns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Booking ID",
      align: "center",
      key: "booking_id",
      render: (_, record) => record?.booking?.booking_id || record?.rental_booking?.booking_id || "-",
    },
    {
      title: "Payment Request Date",
      align: "center",
      dataIndex: "requested_at",
      key: "requested_at",
      render: (record) => DateToLocale(record),
    },
    {
      title: "Amount",
      align: "center",
      dataIndex: "refund_amount",
      key: "refund_amount",
      render: (refund_amount, record) => {
        const currency = record?.booking?.currency || record?.rental_booking?.currency;
        const currencySymbol = currency === "INR" ? "₹" : currency;
        return `${currencySymbol} ${refund_amount}`;
      },
    },
    {
      title: "Refund Reason",
      align: "center",
      dataIndex: "refund_reason_from_user",
      key: "refund_reason_from_user",
      render: (text) => (
        <Tooltip placement="top" title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 200,
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge
            color={status === "requested" ? "blue" : status === "rejected" ? "red" : "green"}
            text={ToFirstCapital(status)}
          />
        </span>
      ),
    },
  ];

  // Only add Action column for super_admin
  if (role === "super_admin") {
    baseColumns.push({
      title: "Action",
      align: "center",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              {record.status !== "approved" && record.status !== "requested" && (
                <Menu.Item key="view" onClick={() => openViewReasonPopup(record)}>
                  View Reason
                </Menu.Item>
              )}
              {record.status !== "rejected" && record.status !== "requested" && (
                <Menu.Item key="no-reason">
                  No Reason
                </Menu.Item>
              )}
              {record.status !== "approved" && record.status !== "rejected" && (
                <Menu.Item key="Approved" onClick={() => openApprovePopup(record)}>
                  Approved
                </Menu.Item>
              )}
              {record.status !== "rejected" && record.status !== "approved" && (
                <Menu.Item key="Rejected" onClick={() => openRejectPopup(record)}>
                  Rejected
                </Menu.Item>
              )}
            </Menu>
          }
          trigger={["click"]}
        >
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    });
  }

  return baseColumns;
};

export const columnsRefunds = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Transaction ID",
    align: "center",
    dataIndex: "transaction_id",
    key: "payment_id",
  },
  {
    title: "Payment Date",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Amount",
    align: "center",
    dataIndex: "amount",
    key: "amount",
    render: (record) => record?.toFixed(2),
  },
  {
    title: "User Name",
    align: "center",
    dataIndex: "user_id",
    key: "user_id",
    render: (record) => record?.name || "N/A",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "approved" || status === "completed" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsNews = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "News ID",
    align: "center",
    dataIndex: "news_id",
    key: "news_id",
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  // {
  //   title: "Start Date",
  //   align: "center",
  //   dataIndex: "start_date",
  //   key: "start_date",
  //   render: (date) => {
  //     return date ? DateToLocale(date) : "N/A";
  //   },
  // },
  // {
  //   title: "End Date",
  //   align: "center",
  //   dataIndex: "end_date",
  //   key: "end_date",
  //   render: (date) => {
  //     return date ? DateToLocale(date) : "N/A";
  //   },
  // },
  {
    title: "Date",
    align: "center",
    dataIndex: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/news_and_articles/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/news_and_articles/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {canEdit &&
              <Menu.Item
                style={{ color: "red" }}
                key="Delete"
                onClick={async () => {
                  await DeleteFunction("/news/remove", record._id);
                  window.location.reload();
                }}
              >
                Delete
              </Menu.Item>
            }
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsNewsBrand = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Brand Logo",
    dataIndex: "brand_logo",
    key: "brand_logo",
    align: "center",
    render: (image) =>
      image ? (
        <img src={image} alt="Voucher" style={{ width: 50, height: 50, borderRadius: "20%", objectFit: "contain", border: "1px solid" }} />
      ) : (
        "N/A"
      ),
  },
  {
    title: "Title",
    align: "center",
    dataIndex: "title",
    key: "title",
    render: (text) => (
      <Tooltip placement="top" title={text}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 300,
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Company Name",
    align: "center",
    dataIndex: "company_name",
    key: "company_name",

    render: (text) => (
      <Tooltip placement="top" title={text || "N/A"}>
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 350,
          }}
        >
          {text || "N/A"}
        </div>
      </Tooltip>
    ),
  },
  {
    title: "Brand Type",
    align: "center",
    dataIndex: "type",
    render: (type) => type
      ? type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      : 'N/A'
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) =>
      date ? new Date(date).toLocaleString() : "N/A",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/fa_brands/view/${record._id}`}>View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/fa_brands/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              key="Delete"
              onClick={async () => {
                await DeleteFunction("/news_brand/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsBrands = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Brand Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img
        src={record ? record : require("../Global Icons/Approve.svg")}
        style={{ width: "50px", height: "50px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsSurroundingIndustries = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Surrounding Industry Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img
        src={record ? record : require("../Global Icons/Approve.svg")}
        style={{ width: "50px", height: "50px" }}
        alt=""
      ></img>
    ),
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  // {
  //   title: "Action",
  //   align: "center",
  //   dataIndex: "action",
  //   key: "",

  //   render: (_, record) => (
  //     <Dropdown
  //       overlay={
  //         <Menu>
  //           <Menu.Item key="view">
  //             <Link to={`/wallet_refund/view/${record._id}`}>View</Link>
  //           </Menu.Item>
  //         </Menu>
  //       }
  //       trigger={["click"]}
  //     >
  //       <Button shape="square" icon={<EllipsisOutlined />} />
  //     </Dropdown>
  //   ),
  // },
];

export const columnsInvites = [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Event",
    align: "center",
    dataIndex: "event",
    key: "event",
    render: (record) => record?.event_name || "No Data",
  },
  {
    title: "User",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Start Date",
    align: "center",
    dataIndex: "start_date",
    key: "start_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "End Date",
    align: "center",
    dataIndex: "end_date",
    key: "end_date",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Guests",
    align: "center",
    dataIndex: "guest_list",
    key: "guest_list",
    render: (record) => (record ? record.length : "0"),
  },
  // {
  //   title: "Status",
  //   align: "center",
  //   dataIndex: "status",
  //   key: "status",
  //   render: (status) => (
  //     <span
  //       style={{
  //         display: "inline-flex",
  //         alignItems: "center",
  //         padding: "4px 8px",
  //         border: "1px solid #d9d9d9",
  //         borderRadius: "10px",
  //       }}
  //     >
  //       <Badge
  //         color={status === "active" ? "green" : "red"}
  //         text={ToFirstCapital(status)}
  //       ></Badge>
  //     </span>
  //   ),
  // },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/invites/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/invite/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsCabs = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Cab Category",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Image",
    align: "center",
    dataIndex: "image",
    key: "image",
    render: (record) => (
      <img style={{ maxHeight: "50px" }} alt="" src={record}></img>
    ),
  },
  {
    title: "Country",
    align: "center",
    dataIndex: "country",
    key: "country",
    render: (record) => (record ? record.country_name : "N/A"),
  },
  {
    title: "Rate per Unit",
    align: "center",
    dataIndex: "rate_per_unit",
    key: "start_date",
  },
  {
    title: "Round Trip Rate per Unit",
    align: "center",
    dataIndex: "round_trip_rate_per_unit",
    key: "round_trip_rate_per_unit",
    render: (value) => value || 0,
  },
  {
    title: "Rate per unit measure In",
    align: "center",
    dataIndex: "rate_per_unit_measure_in",
    key: "rate_per_unit_in",
  },
  {
    title: "Currency",
    align: "center",
    dataIndex: "currency",
    key: "currency",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        ></Badge>
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/cab_settings/view/${record._id}`}>
                View</Link>
            </Menu.Item>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/cab_settings/edit/${record._id}`}>
                  Edit</Link>
              </Menu.Item>
            }
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/cab-setting/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu >
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown >
    ),
  },
];

export const columnsAdmins = (canEdit) => [
  {
    title: "Sr.No.",
    align: "center",
    key: "srno",
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Created On",
    align: "center",
    dataIndex: "created_at",
    key: "created_at",
    render: (record) => DateToLocale(record),
  },
  {
    title: "Contact Number",
    align: "center",
    dataIndex: "contact_number",
    key: "contact_number",
  },
  {
    title: "Role",
    align: "center",
    dataIndex: "role",
    key: "role",
    render: (role) => ToFirstCapital(role),
  },
  {
    title: "Action",
    align: "center",
    dataIndex: "action",
    key: "",

    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            {canEdit &&
              <Menu.Item key="edit">
                <Link to={`/manage_admins/edit/${record._id}`}>Edit</Link>
              </Menu.Item>
            }
            <Menu.Item key="view">
              <Link to={`/manage_admins/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/admin/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];


export const columnsAccessList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Admin ID",
    align: "center",
    dataIndex: "admin_id",
    key: "admin_id",
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    align: "center",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    align: "center",
    dataIndex: "role",
    key: "role",
    render: (role) => ToFirstCapital(role),
  },
  {
    title: "Department",
    align: "center",
    dataIndex: "department",
    key: "department",
    render: (dept) => ToFirstCapital(dept || "N/A"),
  },
  {
    title: "Designation",
    align: "center",
    dataIndex: "designation",
    key: "designation",
  },
  {
    title: "Access Code",
    align: "center",
    dataIndex: "access_code",
    key: "access_code",
    render: (codes) => codes?.join(", ") || "None",
  },
  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9", // Light gray border
          borderRadius: "10px", // Rounded edges
        }}
      >
        <Badge
          color={
            status === "block" || status === "unblock" ? "green" : "red"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="edit">
              <Link to={`/manage_admins/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            <Menu.Item key="view">
              <Link to={`/manage_admins/view/${record._id}`}>View</Link>
            </Menu.Item>
            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/admin/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsUserAppointmentList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },

  {
    title: "User ID",
    align: "center",
    render: (_, record) => record?.user?.user_id || "N/A",
  },

  {
    title: "User Name",
    align: "center",
    render: (_, record) => record?.user?.name || "N/A",
  },

  {
    title: "User Email",
    align: "center",
    render: (_, record) => record?.user?.email || "N/A",
  },

  {
    title: "Contact",
    align: "center",
    render: (_, record) =>
      record?.user
        ? `${record.user.country_code || ""} ${record.user.contact_number || ""}`
        : "N/A",
  },

  {
    title: "Agent Name",
    align: "center",
    render: (_, record) =>
      record?.agent?.length > 0 ? record.agent[0].name : "Not Assigned",
  },

  {
    title: "City",
    align: "center",
    render: (_, record) =>
      record?.cities?.length > 0
        ? record.cities.map((c) => c.city_name).join(", ")
        : "N/A",
  },

  {
    title: "Appointment Date",
    align: "center",
    dataIndex: "appointment_date",
    render: (date) =>
      date ? new Date(date).toLocaleDateString() : "N/A",
  },

  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "pending"
              ? "orange"
              : status === "failed"
                ? "red"
                : "green"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },

  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "accepted"
              ? "orange"
              : status === "requested"
                ? "blue"
                : status === "ontheway"
                  ? "yellow"
                  : status === "declined" || status === "cancelled"
                    ? "red"
                    : "green"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },

  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) =>
      date ? new Date(date).toLocaleString() : "N/A",
  },

  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/home_visit/view/${record._id}`}>View</Link>
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBrandsLeasingList = (currentPage, pageSize, handleStatusChange, canEdit) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Project Name ",
    align: "center",
    dataIndex: "project_id",
    render: (project_id) => project_id.project_name || "N/A",
  },
  {
    title: "Project ID",
    align: "center",
    dataIndex: "project_id",
    render: (project_id) => project_id.project_id || "N/A",
  },
  {
    title: "Name",
    align: "center",
    dataIndex: "name",
    render: (name) => name || "N/A",
  },
  {
    title: "Image",
    align: "center",
    render: (_, record) => (
      <img
        src={record.image || "/placeholder-image.png"}
        alt={record.name || "Brand"}
        style={{ width: "50px", height: "50px", objectFit: "contain", borderRadius: "8px" }}
        onError={(e) => {
          e.target.src = "/placeholder-image.png";
        }}
      />
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    key: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={status === "active" ? "green" : "red"}
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/brands_leasing/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/brands_leasing/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                style={{ color: "green" }}
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                style={{ color: "red" }}
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsBlogList = (currentPage, pageSize, fetchDetails, canEdit, handleStatusChange) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "center",
    render: (title) => (
      <span
        style={{
          fontWeight: 500,
          color: "#0D1A52",
          maxWidth: 220,
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={title}
      >
        {title || "—"}
      </span>
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    align: "center",
    render: (desc) => (
      <span
        style={{
          color: "#6b7280",
          fontSize: "13px",
          maxWidth: 260,
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={desc}
      >
        {desc || "—"}
      </span>
    ),
  },
  {
    title: "Image",
    dataIndex: "blog_images",
    key: "blog_images",
    align: "center",
    render: (images) =>
      images?.[0] ? (
        <img
          src={images[0]}
          alt="Blog"
          style={{
            width: 60,
            height: 40,
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #e0e0e0",
          }}
        />
      ) : (
        <span style={{ color: "#999" }}>No Image</span>
      ),
  },
  {
    title: "Category",
    dataIndex: "category",
    key: "category",
    align: "center",
    render: (category) => (
      <span
        style={{
          background: category === "trending" ? "#fff7ed" : "#f0f4ff",
          color: category === "trending" ? "#c2410c" : "#0D1A52",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          textTransform: "capitalize",
        }}
      >
        {category?.replace("_", " ") || "—"}
      </span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (status) => (
      <span
        style={{
          background: status === "active" ? "#e6f9f0" : "#fef2f2",
          color: status === "active" ? "#0a7c42" : "#dc2626",
          padding: "3px 10px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 600,
          textTransform: "capitalize",
        }}
      >
        {status || "—"}
      </span>
    ),
  },
  {
    title: "Action",
    align: "center",
    key: "action",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item key="view">
              <Link to={`/blog/view/${record._id}`}>View</Link>
            </Menu.Item>
            <Menu.Item key="edit">
              <Link to={`/blog/edit/${record._id}`}>Edit</Link>
            </Menu.Item>
            {/* Show Active only if status is NOT active */}
            {record.status !== "active" && canEdit && (
              <Menu.Item
                key="Active"
                onClick={() => handleStatusChange(record, "active")}
              >
                Active
              </Menu.Item>
            )}

            {record.status !== "inactive" && canEdit && (
              <Menu.Item
                key="Inactive"
                onClick={() => handleStatusChange(record, "inactive")}
              >
                Inactive
              </Menu.Item>
            )}

            {/* <Menu.Item
              style={{ color: "red" }}
              onClick={async () => {
                await DeleteFunction("/coupon/remove", record._id);
                window.location.reload();
              }}
            >
              Delete
            </Menu.Item> */}
          </Menu>
        }
        trigger={["click"]}
      >
        <Button shape="square" icon={<EllipsisOutlined />} />
      </Dropdown>
    ),
  },
];

export const columnsVrVisitList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },

  {
    title: "User ID",
    align: "center",
    render: (_, record) => record?.user_id || "N/A",
  },

  {
    title: "User Name",
    align: "center",
    render: (_, record) => record?.user_name || "N/A",
  },

  {
    title: "User Email",
    align: "center",
    render: (_, record) => record?.user_email || "N/A",
  },

  {
    title: "Contact",
    align: "center",
    render: (_, record) => record?.user_phone || "N/A",
  },

  {
    title: "Agent Name",
    align: "center",
    render: (_, record) => record?.agent_name || "Not Assigned",
  },

  {
    title: "Builder",
    align: "center",
    render: (_, record) => record?.builder_name || "N/A",
  },

  {
    title: "Project",
    align: "center",
    render: (_, record) => record?.project_name || "N/A",
  },

  {
    title: "VR Views",
    align: "center",
    dataIndex: "vr_view_count",
    render: (count) => (
      <strong style={{ color: "#1890ff" }}>
        {count || 0}
      </strong>
    ),
  },

  {
    title: "Created At",
    align: "center",
    dataIndex: "created_at",
    render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
  },
];


export const columnsUserPaymentList = (currentPage, pageSize) => [
  {
    title: "Sr No.",
    align: "center",
    render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
  },

  {
    title: "User ID",
    align: "center",
    dataIndex: "user_id",
    render: (id) => id || "N/A",
  },

  {
    title: "User Name",
    align: "center",
    dataIndex: "user_name",
    render: (name) => name || "N/A",
  },

  {
    title: "User Email",
    align: "center",
    dataIndex: "user_email",
    render: (email) => email || "N/A",
  },

  {
    title: "Booking Amount",
    align: "center",
    dataIndex: "booking_amount",
    render: (amount) => (
      <span style={{
        background: amount === 0 ? '#f6ffed' : 'rgb(176 225 255)',
        color: amount === 0 ? '#52c41a' : '#00438a',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500
      }}>
        {amount === 0 ? 'FREE' : `₹${amount || 0}`}
      </span>
    ),
  },

  {
    title: "Appointment Date",
    align: "center",
    dataIndex: "appointment_date",
    render: (date) =>
      date ? new Date(date).toLocaleDateString() : "N/A",
  },
  {
    title: "Payment Status",
    align: "center",
    dataIndex: "payment_status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "pending"
              ? "blue"
              : status === "completed"
                ? "green"
                : status === "failed" || status === "refunded"
                  ? "red"
                  : "orange"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },

  {
    title: "Status",
    align: "center",
    dataIndex: "status",
    render: (status) => (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
        }}
      >
        <Badge
          color={
            status === "accepted"
              ? "orange"
              : status === "requested"
                ? "blue"
                : status === "ontheway"
                  ? "yellow"
                  : status === "declined" || status === "cancelled"
                    ? "red"
                    : "green"
          }
          text={ToFirstCapital(status)}
        />
      </span>
    ),
  },
];

